<template>
  <div style="background-color: #f8f9fb">
    <DialogMensagem ref="dialogMensagem" />
    <v-dialog
      v-model="showNewAttendanceDialog"
      max-width="600"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline primary white--text">
          Novo Atendimento
        </v-card-title>
        <v-card-text class="pa-4">
          <v-form ref="form" v-model="valid" lazy-validation>
            <!-- 1. Template selecionado -->
            <div class="mb-4">
              <!-- Select de Templates -->
              <v-select
                v-model="selectedTemplateId"
                :items="templates"
                item-text="nome"
                item-value="id"
                label="Selecione um template"
                :loading="loadingTemplates"
                :disabled="loadingTemplates"
                @change="onTemplateSelectChange"
                clearable
                outlined
                hide-details
                dense
              ></v-select>
              <v-alert
                v-if="!selectedTemplate"
                type="info"
                dense
                class="mt-2 mb-3 py-1"
              >
                Selecione um template para iniciar uma conversa
              </v-alert>

              <!-- Exibição do template (apenas quando selecionado) -->
              <v-card v-if="selectedTemplate" flat outlined class="mt-2">
                <v-card-subtitle class="caption">
                  Template: {{ selectedTemplate.nome }}
                </v-card-subtitle>
                <v-card-text class="pa-2">
                  <div class="caption">
                    {{ selectedTemplate.content }}
                  </div>
                </v-card-text>
              </v-card>
            </div>
            <div class="mb-4">
              <v-text-field
                v-model="phoneNumber"
                label="Número de telefone"
                prefix="+55"
                required
                outlined
                dense
                hide-details
              ></v-text-field>
            </div>
            <template v-if="selectedTemplate">
              <div
                v-for="(param, index) in extractTemplateParams(
                  selectedTemplate.content,
                )"
                :key="index"
                class="mb-2"
              >
                <v-text-field
                  v-model="templateParams[index]"
                  :label="
                    templateParamLabels[index] || `Parâmetro ${index + 1}`
                  "
                  required
                  outlined
                  hide-details
                  dense
                ></v-text-field>
              </div>
            </template>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn text @click="closeNewAttendanceDialog"> Cancelar </v-btn>
          <v-btn
            color="primary"
            :loading="sendingMessage || checkingContact"
            :disabled="
              !phoneNumber || !selectedTemplate || !allParametersFilled
            "
            @click="checkContactAndSend"
          >
            <v-icon left>mdi-send</v-icon>
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container v-if="showFiltroEmpresa" style="background-color: #f8f9fb">
      <v-col cols="12">
        <filtro-empresa
          @filtrar="filterDataEmpresa"
          @showError="showErrorEmpresa = true"
        ></filtro-empresa>
      </v-col>
    </v-container>

    <!-- Empresa selecionada (quando o filtro estiver oculto) -->
    <v-container v-if="!showFiltroEmpresa" style="background-color: #f8f9fb">
      <v-col cols="12" class="d-flex align-center justify-space-between">
        <div>
          <div class="subtitle-2 grey--text">Empresa selecionada</div>
          <div class="font-weight-bold">
            {{ selectedEmpresa ? selectedEmpresa : "Todas" }}
          </div>
          <v-tooltip bottom v-if="channelId">
            <template v-slot:activator="{ on, attrs }">
              <div
                class="grey--text"
                v-bind="attrs"
                v-on="on"
                style="cursor: help"
              >
                <v-icon small class="mr-1">mdi-phone</v-icon>
                {{ telefoneEmpresa || "Sem telefone cadastrado" }}
              </div>
            </template>
            <span>ChannelId: {{ channelId }}</span>
          </v-tooltip>
          <div class="grey--text" v-else>
            <v-icon small class="mr-1">mdi-phone</v-icon>
            Sem telefone cadastrado
          </div>
        </div>
        <v-btn color="primary" small @click="showFiltroEmpresa = true">
          Selecionar outra empresa
        </v-btn>
      </v-col>
    </v-container>

    <base-material-card
      color="primary"
      icon="mdi-chat"
      class="v-card--material-stats"
    >
      <template v-slot:after-heading>
        <div class="ml-auto text-right">
          <div class="grey--text font-weight" style="font-size: 18px">Chat</div>
          <div class="subtitle-2 font-weight-light grey--text">
            Envio de mensagens via WhatsApp
          </div>
        </div>
      </template>

      <!-- Botão Novo Atendimento -->
      <div class="mb-4 d-flex justify-end px-4">
        <v-btn
          color="primary"
          @click="showNewAttendanceDialog = true"
          :disabled="!empresaSelecionada"
        >
          <v-icon left>mdi-plus-circle</v-icon>
          Novo Atendimento
        </v-btn>
      </div>
      <v-container fluid class="pt-0">
        <v-row class="mt-2">
          <!-- Coluna Esquerda: Lista de Protocolos -->
          <v-col
            :cols="12"
            :md="showingClientDetails ? 3 : 4"
            v-if="!showingClientDetails"
          >
            <!-- Lista de Protocolos -->
            <v-card
              outlined
              class="protocols-card"
              style="
                height: calc(100vh - 200px);
                display: flex;
                flex-direction: column;
              "
            >
              <!-- Título e Campo de Busca -->
              <div
                class="pa-3"
                style="flex-shrink: 0; border-bottom: 1px solid #e0e0e0"
              >
                <div class="d-flex align-center mb-3">
                  <span class="subtitle-1 font-weight-bold">Protocolos</span>
                  <v-spacer></v-spacer>

                  <!-- Switch de Notificações -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <div v-on="on" class="d-flex align-center">
                        <v-icon
                          small
                          class="mr-1"
                          :color="notificacoesHabilitadas ? 'primary' : 'grey'"
                        >
                          {{
                            notificacoesHabilitadas
                              ? "mdi-bell"
                              : "mdi-bell-off"
                          }}
                        </v-icon>
                        <v-switch
                          v-model="notificacoesHabilitadas"
                          dense
                          hide-details
                          class="mt-0 pt-0"
                          @change="toggleNotificacoes"
                        ></v-switch>
                      </div>
                    </template>
                    <span>{{
                      notificacoesHabilitadas
                        ? "Notificações ativadas"
                        : "Notificações desativadas"
                    }}</span>
                  </v-tooltip>
                </div>

                <!-- Filtros em linha separada -->
                <div class="d-flex align-center mb-3">
                  <!-- Filtro de Status -->
                  <v-select
                    v-model="protocolStatusFilter"
                    :items="statusFilterOptions"
                    item-text="label"
                    item-value="value"
                    dense
                    outlined
                    hide-details
                    class="mr-2"
                    label="Status"
                  >
                    <template v-slot:selection="{ item }">
                      <v-icon small left :color="item.color">
                        {{ item.icon }}
                      </v-icon>
                      <span class="caption">{{ item.label }}</span>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-icon small left :color="item.color">
                        {{ item.icon }}
                      </v-icon>
                      <span>{{ item.label }}</span>
                    </template>
                  </v-select>

                  <!-- Filtro de Fila -->
                  <v-select
                    v-model="selectedFilaId"
                    :items="filas"
                    item-text="nomeFila"
                    item-value="id"
                    dense
                    outlined
                    hide-details
                    label="Fila"
                    v-if="filas.length > 0"
                    @change="consultarProtocolos"
                  >
                    <template v-slot:selection="{ item }">
                      <v-icon small left color="primary">
                        mdi-folder-account
                      </v-icon>
                      <span class="caption">{{ item.nomeFila }}</span>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-icon small left color="primary">
                        mdi-folder-account
                      </v-icon>
                      <span>{{ item.nomeFila }}</span>
                    </template>
                  </v-select>

                  <v-spacer></v-spacer>
                </div>

                <div class="my-3 d-flex align-center justify-space-between">
                  <v-chip
                    :color="meusAtendimentos ? 'primary' : '#4A4A4A'"
                    :text-color="'white'"
                    @click="meusAtendimentos = !meusAtendimentos"
                    link
                  >
                    <v-icon
                      class="mr-2"
                      :color="meusAtendimentos ? 'white' : 'white'"
                    >
                      mdi-account
                    </v-icon>
                    Meus Atendimentos
                  </v-chip>
                  <v-btn
                    text
                    elevation="0"
                    class="mr-2"
                    small
                    @click="consultarProtocolos"
                    :loading="loadingProtocols"
                    title="Atualizar protocolos"
                  >
                    <v-icon left small>mdi-refresh</v-icon>
                    Atualizar
                  </v-btn>
                </div>

                <!-- Campo de busca -->
                <v-text-field
                  v-model="protocolSearch"
                  label="Filtrar por protocolo ou contato"
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  dense
                  clearable
                  hide-details="auto"
                ></v-text-field>
              </div>
              <!-- Lista de Protocolos -->
              <div
                style="
                  flex: 1;
                  overflow: hidden;
                  display: flex;
                  flex-direction: column;
                  min-height: 0;
                "
              >
                <v-skeleton-loader
                  v-if="loadingProtocols"
                  type="list-item-three-line"
                ></v-skeleton-loader>
                <div
                  v-else
                  class="protocols-list-container"
                  style="flex: 1; overflow-y: auto"
                >
                  <v-list dense class="py-0">
                    <v-list-item
                      v-for="protocolo in filteredProtocols"
                      :key="protocolo.id"
                      @click="selectProtocol(protocolo)"
                      :class="{
                        'primary lighten-5':
                          protocoloSelecionado?.id === protocolo.id,
                      }"
                      class="px-3"
                      style="cursor: pointer; border-bottom: 1px solid #e0e0e0"
                    >
                      <v-list-item-content class="py-2">
                        <!-- Telefone / Chat -->
                        <v-list-item-title
                          class="font-weight-bold mb-2 d-flex align-center justify-space-between"
                        >
                          <div class="d-flex align-center">
                            <v-icon small color="primary" class="mr-1"
                              >mdi-phone</v-icon
                            >
                            <span>{{ protocolo.chatId }}</span>
                          </div>

                          <!-- Mensagem não lida -->
                          <v-badge
                            v-if="protocolo.temMensagemNaoLida"
                            color="red"
                            overlap
                            dot
                          >
                            <v-icon small>mdi-bell</v-icon>
                          </v-badge>
                        </v-list-item-title>

                        <!-- Nome do contato -->
                        <div v-if="protocolo.nomeContato" class="mb-2">
                          <v-icon x-small color="primary" class="mr-1"
                            >mdi-account</v-icon
                          >
                          <strong>{{ protocolo.nomeContato }}</strong>
                        </div>

                        <v-list-item-subtitle>
                          <!-- Protocolo + Status -->
                          <div class="d-flex justify-space-between mb-1">
                            <div>
                              <strong>Protocolo:</strong>
                              {{ protocolo.numeroProtocolo }}
                            </div>

                            <v-chip
                              x-small
                              :color="chipStatusProtocolo(protocolo).color"
                              :dark="
                                chipStatusProtocolo(protocolo).color === 'grey'
                              "
                              :style="
                                chipStatusProtocolo(protocolo).color ===
                                '#F2C94C'
                                  ? 'color: #1a1a1a'
                                  : undefined
                              "
                            >
                              {{ chipStatusProtocolo(protocolo).text }}
                            </v-chip>
                          </div>

                          <!-- Origem -->
                          <div class="caption mb-1">
                            <strong>Origem:</strong>
                            {{
                              protocolo.origem === "INBOUND"
                                ? "Cliente"
                                : "Empresa"
                            }}
                          </div>

                          <!-- Data de abertura -->
                          <div class="caption">
                            <strong>Aberto em:</strong>
                            {{ formatDateTimeBR(protocolo.dataAbertura) }}
                          </div>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item
                      v-if="filteredProtocols.length === 0"
                      class="px-3"
                    >
                      <v-list-item-content>
                        <v-list-item-subtitle class="text-center py-4">
                          {{
                            protocolSearch
                              ? "Nenhum protocolo encontrado com o filtro aplicado"
                              : "Nenhum protocolo encontrado"
                          }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </div>
            </v-card>
          </v-col>

          <!-- Coluna Direita: Chat -->
          <v-col :cols="12" md="8">
            <!-- Chat vazio quando não há protocolo selecionado -->
            <v-card
              v-if="!protocoloSelecionado"
              outlined
              class="d-flex align-center justify-center"
              style="height: calc(100vh - 200px)"
            >
              <v-card-text class="text-center">
                <v-icon size="64" color="grey lighten-1"
                  >mdi-chat-outline</v-icon
                >
                <div class="headline mt-4 grey--text">
                  Selecione um protocolo para visualizar o chat
                </div>
              </v-card-text>
            </v-card>

            <!-- Chat History Section -->
            <v-card
              v-else
              outlined
              class="chat-card"
              style="
                height: calc(100vh - 200px);
                display: flex;
                flex-direction: column;
              "
            >
              <!-- Título fixo no topo -->
              <div
                class="pa-2"
                style="
                  flex-shrink: 0;
                  border-bottom: 1px solid #e0e0e0;
                  background-color: white;
                "
              >
                <v-row>
                  <!-- Informações do protocolo -->
                  <v-col cols="6">
                    <v-chip small class="mr-2">
                      <v-icon left x-small>mdi-identifier</v-icon>
                      Protocolo: {{ selectedProtocolData.numeroProtocolo }}
                    </v-chip>
                    <v-chip
                      v-if="selectedProtocolData"
                      small
                      color="info"
                      text-color="white"
                    >
                      <v-icon left x-small>mdi-phone</v-icon>
                      {{ selectedProtocolData.chatId }}
                    </v-chip>
                  </v-col>
                  <v-col
                    cols="6"
                    class="d-flex align-center justify-end"
                    v-if="selectedProtocolData"
                  >
                    <!-- Detalhes do Cliente -->
                    <v-btn
                      :color="showingClientDetails ? 'error' : 'info'"
                      :outlined="!showingClientDetails"
                      elevation="2"
                      class="mr-2"
                      @click="toggleClientDetails"
                      :disabled="!selectedProtocolData"
                      x-small
                      :title="
                        showingClientDetails
                          ? 'Ocultar detalhes do cliente'
                          : 'Detalhes do cliente'
                      "
                    >
                      <v-icon left x-small>{{
                        showingClientDetails
                          ? "mdi-eye-off"
                          : "mdi-account-details"
                      }}</v-icon>
                      {{ showingClientDetails ? "Ocultar" : "Detalhes" }}
                    </v-btn>

                    <v-btn
                      v-if="
                        !isCurrentUserAttendant && !isCurrentUserParticipant
                      "
                      color="warning"
                      elevation="2"
                      class="mr-2"
                      @click="abrirDialogTransferenciaFila"
                      x-small
                      title="Transferir Fila"
                    >
                      <v-icon left x-small>mdi-swap-horizontal</v-icon>
                      Transferir Fila
                    </v-btn>

                    <!-- Aceitar Atendimento -->
                    <v-btn
                      v-if="
                        !isCurrentUserAttendant && !isCurrentUserParticipant
                      "
                      color="success"
                      elevation="2"
                      class="mr-2"
                      x-small
                      @click="aceitarAtendimento"
                      title="Aceitar atendimento"
                    >
                      <v-icon left x-small>mdi-check-circle</v-icon>
                      Aceitar
                    </v-btn>

                    <!-- Menu de Ações -->
                    <v-menu
                      v-if="isCurrentUserAttendant || isCurrentUserParticipant"
                      offset-y
                      left
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          elevation="2"
                          v-bind="attrs"
                          v-on="on"
                          x-small
                        >
                          <v-icon left x-small>mdi-dots-vertical</v-icon>
                          Ações
                          <v-icon right x-small>mdi-menu-down</v-icon>
                        </v-btn>
                      </template>
                      <v-list dense>
                        <v-list-item
                          v-if="isCurrentUserAttendant"
                          @click="abrirDialogTransferencia"
                        >
                          <v-list-item-icon>
                            <v-icon small color="info"
                              >mdi-account-switch</v-icon
                            >
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              Transferir Atendimento
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                          v-if="isCurrentUserAttendant"
                          @click="abrirDialogParticipante"
                        >
                          <v-list-item-icon>
                            <v-icon small color="primary"
                              >mdi-account-plus</v-icon
                            >
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              Adicionar Participante
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                          v-if="isCurrentUserAttendant"
                          @click="abrirDialogTransferenciaFila"
                        >
                          <v-list-item-icon>
                            <v-icon small color="info"
                              >mdi-swap-horizontal</v-icon
                            >
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              Transferir Fila
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                          v-if="
                            isCurrentUserAttendant && temParticipanteNoProtocolo
                          "
                          @click="removerParticipante"
                        >
                          <v-list-item-icon>
                            <v-icon small color="warning"
                              >mdi-account-minus</v-icon
                            >
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              Remover Participante
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item @click="sairAtendimento">
                          <v-list-item-icon>
                            <v-icon small color="orange"
                              >mdi-exit-to-app</v-icon
                            >
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              Sair do Atendimento
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                          v-if="
                            isCurrentUserAttendant && !isCurrentUserParticipant
                          "
                          @click="finalizarProtocolo"
                        >
                          <v-list-item-icon>
                            <v-icon small color="red">mdi-close-circle</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>
                              Finalizar Protocolo
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-col>
                </v-row>
              </div>

              <!-- Área de mensagens (flexível) -->
              <div
                style="
                  flex: 1;
                  overflow-y: auto;
                  overflow-x: hidden;
                  min-height: 0;
                  padding: 12px;
                "
              >
                <v-skeleton-loader
                  v-if="loadingMessages"
                  type="list-item-three-line"
                  :loading="loadingMessages"
                ></v-skeleton-loader>

                <div v-else class="chat-container">
                  <div
                    v-for="message in messages"
                    :key="message.id"
                    :class="[
                      'message-bubble mb-2 pa-2',
                      message.direcao === 'OUTBOUND'
                        ? 'outgoing-message'
                        : 'incoming-message',
                    ]"
                  >
                    <!-- Texto -->
                    <div v-if="message.tipo === 'text'">
                      {{ message.conteudo }}
                    </div>

                    <!-- vCard - Cartão de contato -->
                    <div
                      v-else-if="message.tipo === 'vcard'"
                      class="message-media-card"
                    >
                      <div class="media-card-header">
                        <v-icon color="primary" small
                          >mdi-card-account-details</v-icon
                        >
                        <span class="media-card-label">Cartão de contato</span>
                      </div>
                      <div class="media-card-body">
                        <pre class="vcard-content">{{ message.conteudo }}</pre>
                      </div>
                    </div>

                    <!-- Geo - Localização -->
                    <div
                      v-else-if="message.tipo === 'geo'"
                      class="message-media-card"
                    >
                      <div class="media-card-header">
                        <v-icon color="success" small>mdi-map-marker</v-icon>
                        <span class="media-card-label">Localização</span>
                      </div>
                      <div class="media-card-body">
                        <div class="geo-content">
                          {{ message.conteudo || "Localização compartilhada" }}
                        </div>
                        <a
                          v-if="getMapsUrl(message.conteudo)"
                          :href="getMapsUrl(message.conteudo)"
                          target="_blank"
                          class="geo-link"
                        >
                          <v-icon x-small>mdi-open-in-new</v-icon>
                          Ver no mapa
                        </a>
                      </div>
                    </div>

                    <!-- Chamada perdida -->
                    <div
                      v-else-if="message.tipo === 'missing_call'"
                      class="message-media-card message-media-card--subtle"
                    >
                      <div class="media-card-header">
                        <v-icon color="grey" small>mdi-phone-missed</v-icon>
                        <span class="media-card-label">Chamada perdida</span>
                      </div>
                    </div>

                    <!-- Tipo não suportado / desconhecido -->
                    <div
                      v-else-if="
                        ['unsupported', 'unknown'].includes(message.tipo)
                      "
                      class="message-media-card message-media-card--subtle"
                    >
                      <div class="media-card-header">
                        <v-icon color="grey" small
                          >mdi-help-circle-outline</v-icon
                        >
                        <span class="media-card-label">{{
                          message.tipo === "unsupported"
                            ? "Tipo não suportado"
                            : "Mensagem desconhecida"
                        }}</span>
                      </div>
                      <div v-if="message.conteudo" class="media-card-body">
                        {{ message.conteudo }}
                      </div>
                    </div>

                    <!-- BOT -->
                    <div
                      v-else-if="message.tipo === 'BOT'"
                      class="message-media-card"
                    >
                      <div class="media-card-header">
                        <v-icon color="secondary" small>mdi-robot</v-icon>
                        <span class="media-card-label">BOT</span>
                      </div>
                      <div class="media-card-body">
                        {{ message.conteudo || "Mensagem do BOT" }}
                      </div>
                    </div>

                    <!-- Template WABA -->
                    <div
                      v-else-if="message.tipo === 'wapi_template'"
                      class="message-media-card"
                    >
                      <div class="media-card-header">
                        <v-icon color="secondary" small
                          >mdi-format-list-bulleted-type</v-icon
                        >
                        <span class="media-card-label">Template</span>
                      </div>
                      <div class="media-card-body">
                        {{ message.conteudo || "Mensagem template" }}
                      </div>
                    </div>

                    <!-- Mídia com preview: imagem, vídeo, áudio, PDF -->

                    <div
                      v-else-if="message.contentUri && hasMediaPreview(message)"
                      class="message-media-card"
                    >
                      <div class="media-card-header">
                        <v-icon small :color="getTipoIconColor(message.tipo)">
                          {{ getTipoIcon(message.tipo) }}
                        </v-icon>
                        <span class="media-card-label">{{
                          getTipoLabel(message.tipo)
                        }}</span>
                        <span
                          v-if="getFileName(message.contentUri) !== 'arquivo'"
                          class="media-card-filename"
                        >
                          {{ getFileName(message.contentUri) }}
                        </span>
                      </div>
                      <div class="media-card-preview">
                        <!-- Imagem -->
                        <img
                          v-if="message.tipo === 'image'"
                          :src="getMediaUrl(message.contentUri)"
                          alt="Imagem"
                          class="media-preview-img"
                          @click="
                            abrirEmNovaAba(getMediaUrl(message.contentUri))
                          "
                        />
                        <!-- Vídeo -->
                        <video
                          v-else-if="message.tipo === 'video'"
                          :src="getMediaUrl(message.contentUri)"
                          controls
                          class="media-preview-video"
                        />
                        <!-- Áudio -->
                        <div
                          v-else-if="message.tipo === 'audio'"
                          class="media-preview-audio"
                        >
                          <audio
                            :src="getMediaUrl(message.contentUri)"
                            controls
                          />
                        </div>
                        <!-- PDF -->
                        <iframe
                          v-else-if="
                            message.tipo === 'document' &&
                            isPdfDocument(message.contentUri)
                          "
                          :src="getMediaUrl(message.contentUri)"
                          class="media-preview-iframe"
                          title="Visualizar PDF"
                        />
                      </div>
                      <div class="media-card-actions">
                        <v-btn
                          small
                          color="primary"
                          :href="message.contentUri"
                          target="_blank"
                          :download="getFileName(message.contentUri)"
                          text
                          class="pa-0"
                        >
                          <v-icon left small>mdi-download</v-icon>
                          Baixar
                        </v-btn>
                      </div>
                    </div>

                    <!-- Documento/arquivo sem preview -->
                    <div
                      v-else-if="message.contentUri && message.tipo !== 'text'"
                      class="message-media-card"
                    >
                      <div class="media-card-header">
                        <v-icon small color="grey">
                          {{ getTipoIcon(message.tipo) }}
                        </v-icon>
                        <span class="media-card-label">{{
                          getTipoLabel(message.tipo)
                        }}</span>
                        <span class="media-card-filename">
                          {{ getFileName(message.contentUri) }}
                        </span>
                      </div>
                      <div
                        class="media-card-actions media-card-actions--standalone"
                      >
                        <v-btn
                          small
                          color="primary"
                          :href="message.contentUri"
                          target="_blank"
                          :download="getFileName(message.contentUri)"
                          outlined
                        >
                          <v-icon left small>mdi-download</v-icon>
                          Baixar arquivo
                        </v-btn>
                      </div>
                    </div>

                    <!-- Fallback -->
                    <div
                      v-else
                      class="message-media-card message-media-card--subtle"
                    >
                      <div class="media-card-body">
                        {{
                          message.conteudo || "(arquivo ou mídia sem conteúdo)"
                        }}
                      </div>
                    </div>
                    <div class="message-time">
                      {{ formatarDataMensagem(message.dataEnvio) }}
                    </div>
                    <div
                      v-if="
                        message.direcao === 'OUTBOUND' &&
                        message.status !== null
                      "
                      class="caption text-right mt-1"
                      :class="{
                        'success--text': message.status === 3,
                        'info--text': message.status === 2,
                        'grey--text':
                          message.status !== 2 &&
                          message.status !== 3 &&
                          message.status !== -2,
                        'error--text': message.status === -2,
                      }"
                    >
                      <template v-if="message.status === 3">
                        <v-icon x-small color="success">mdi-check-all</v-icon>
                        <span class="ml-1">Lido</span>
                      </template>

                      <template v-else-if="message.status === 2">
                        <v-icon x-small color="info">mdi-check-all</v-icon>
                        <span class="ml-1">Entregue</span>
                      </template>

                      <template v-else-if="message.status === -2">
                        <v-icon x-small color="error">mdi-alert-circle</v-icon>
                        <span class="ml-1">Erro ao enviar</span>
                      </template>

                      <template
                        v-else-if="message.status === 0 || message.status === 1"
                      >
                        <v-icon x-small color="grey">mdi-check</v-icon>
                        <span class="ml-1">Enviada</span>
                      </template>
                    </div>
                  </div>

                  <div v-if="messages.length === 0" class="text-center pa-4">
                    Nenhuma mensagem encontrada
                  </div>
                </div>
              </div>

              <!-- Campo de envio fixo na parte inferior -->
              <div
                class="pa-2"
                style="
                  flex-shrink: 0;
                  border-top: 1px solid #e0e0e0;
                  background-color: white;
                "
              >
                <!-- Mensagem informativa quando não é o atendente -->
                <v-alert
                  v-if="
                    !isCurrentUserAttendant &&
                    selectedProtocolData &&
                    !isCurrentUserParticipant
                  "
                  type="info"
                  dense
                  text
                  class="mb-1 py-1"
                  style="font-size: 12px"
                >
                  Você precisa aceitar o atendimento para enviar mensagens neste
                  protocolo.
                </v-alert>

                <!-- Botões de formatação -->
                <div
                  class="text-formatting-buttons mb-1 d-flex align-center"
                  v-if="isCurrentUserAttendant || isCurrentUserParticipant"
                >
                  <v-btn-toggle dense group class="elevation-0 rounded-lg mr-2">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          small
                          text
                          @click="formatar('bold')"
                          v-on="on"
                          class="px-1"
                        >
                          <v-icon small>mdi-format-bold</v-icon>
                        </v-btn>
                      </template>
                      <span>Negrito</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          small
                          text
                          @click="formatar('italic')"
                          v-on="on"
                          class="px-1"
                        >
                          <v-icon small>mdi-format-italic</v-icon>
                        </v-btn>
                      </template>
                      <span>Itálico</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          small
                          text
                          @click="formatar('underline')"
                          v-on="on"
                          class="px-1"
                        >
                          <v-icon small>mdi-format-underline</v-icon>
                        </v-btn>
                      </template>
                      <span>Sublinhado</span>
                    </v-tooltip>
                  </v-btn-toggle>

                  <v-menu
                    v-model="showEmojiPicker"
                    :close-on-content-click="false"
                    :nudge-width="200"
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn small text v-bind="attrs" v-on="on" class="px-1">
                        <v-icon small>mdi-emoticon-outline</v-icon>
                      </v-btn>
                    </template>
                    <div class="emoji-picker-container">
                      <emoji-picker
                        @emoji-click="onEmojiClick"
                        class="light"
                      ></emoji-picker>
                    </div>
                  </v-menu>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on"></span>
                    </template>
                    <span>Inserir emoji</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        text
                        v-bind="attrs"
                        v-on="on"
                        @click="openFileAttachmentDialog"
                        :disabled="
                          !protocoloSelecionado ||
                          (!isCurrentUserAttendant && !isCurrentUserParticipant)
                        "
                        class="px-1"
                      >
                        <v-icon small>mdi-paperclip</v-icon>
                      </v-btn>
                    </template>
                    <span>Anexar arquivo</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        text
                        v-bind="attrs"
                        v-on="on"
                        @click="openAudioDialog"
                        :disabled="
                          !protocoloSelecionado ||
                          (!isCurrentUserAttendant && !isCurrentUserParticipant)
                        "
                        class="px-1"
                      >
                        <v-icon small>mdi-microphone</v-icon>
                      </v-btn>
                    </template>
                    <span>Gravar áudio</span>
                  </v-tooltip>
                </div>

                <div class="d-flex align-center message-input-area">
                  <v-textarea
                    ref="textareaRef"
                    v-model="freeTextMessage"
                    label="Digite sua mensagem"
                    rows="2"
                    hide-details
                    outlined
                    dense
                    auto-grow
                    :disabled="
                      !isCurrentUserAttendant && !isCurrentUserParticipant
                    "
                    style="flex: 1; max-height: 120px; overflow-y: auto"
                    @keydown.enter="handleEnter"
                  />

                  <v-btn
                    color="primary"
                    small
                    class="ml-2"
                    :loading="sendingMessage"
                    :disabled="
                      sendingMessage ||
                      !freeTextMessage?.trim() ||
                      (!isCurrentUserAttendant && !isCurrentUserParticipant)
                    "
                    @click="enviarMensagem"
                  >
                    Enviar
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-col>

          <v-col v-if="showingClientDetails" cols="12" md="4">
            <v-card
              outlined
              class="client-details-card"
              style="height: calc(100vh - 200px); overflow-y: auto"
            >
              <!-- Cabeçalho do card -->
              <v-card-title>
                <v-icon left color="primary">mdi-account-details</v-icon>
                Detalhes do Cliente
              </v-card-title>

              <!-- Conteúdo principal do card -->
              <v-card-text>
                <!-- Loading -->
                <div v-if="loadingClientInfo" class="text-center py-5">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                  <div class="mt-3">Carregando informações do cliente...</div>
                </div>

                <!-- Erro -->
                <div v-else-if="clientInfoError" class="text-center py-5 pt-12">
                  <v-alert type="error" outlined>
                    {{ clientInfoError }}
                  </v-alert>
                  <v-btn
                    color="primary"
                    @click="fetchClientInfo()"
                    class="mt-3"
                  >
                    <v-icon left>mdi-refresh</v-icon>
                    Tentar novamente
                  </v-btn>
                </div>

                <!-- Sem dados -->
                <div v-else-if="!clientInfo" class="text-center py-5">
                  <v-alert type="info" outlined>
                    Nenhuma informação disponível para este cliente.
                  </v-alert>
                </div>

                <!-- Dados do cliente -->
                <div v-else class="mt-12">
                  <!-- Seletor de cliente -->
                  <div v-if="clientsCount > 1" class="mb-4">
                    <div class="d-flex align-center mb-2">
                      <v-chip color="primary" small class="mr-2">
                        {{ clientsCount }} clientes encontrados
                      </v-chip>
                      <div class="caption">
                        Selecione um cliente para visualizar os detalhes
                      </div>
                    </div>
                    <v-select
                      v-model="selectedClientIndex"
                      :items="
                        clients.map((client, index) => ({
                          text: client.nome || `Cliente ${index + 1}`,
                          value: index,
                        }))
                      "
                      label="Selecione o cliente"
                      outlined
                      dense
                      @change="changeSelectedClient"
                      class="mb-2"
                      color="primary"
                      item-color="primary"
                      hide-details
                    ></v-select>
                  </div>

                  <!-- Informações básicas -->
                  <div class="mb-4">
                    <v-list-item>
                      <v-list-item-avatar
                        size="60"
                        color="primary"
                        class="white--text"
                      >
                        {{
                          clientInfo.nome
                            ? clientInfo.nome.charAt(0).toUpperCase()
                            : "?"
                        }}
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="headline mb-1">{{
                          clientInfo.nome || "Nome não informado"
                        }}</v-list-item-title>
                        <v-list-item-subtitle>
                          <div>
                            <strong>CPF:</strong>
                            {{ formatCpf(clientInfo.cpf) || "Não informado" }}
                          </div>
                          <div>
                            <strong>Idade:</strong>
                            {{ clientInfo.idade || "Não informada" }} anos
                          </div>
                          <div class="caption">
                            <strong>ID do Cliente:</strong>
                            {{
                              clientInfo.idCliente ||
                              clientInfo.Id ||
                              "Não informado"
                            }}
                          </div>
                        </v-list-item-subtitle>

                        <!-- Ações de contato do cliente (barra lateral direita) -->
                        <div class="mt-2 d-flex flex-wrap">
                          <v-btn
                            small
                            color="primary"
                            text
                            class="mr-2 mb-1"
                            @click="openEditClientContactDialogFromSidebar"
                          >
                            <v-icon left small>mdi-pencil</v-icon>
                            Editar contato
                          </v-btn>

                          <v-btn
                            small
                            color="secondary"
                            text
                            class="mb-1"
                            @click="openAddClientInteractionDialog"
                          >
                            <v-icon left small>mdi-message-plus</v-icon>
                            Adicionar interação
                          </v-btn>
                        </div>
                      </v-list-item-content>
                    </v-list-item>

                    <v-divider class="my-3"></v-divider>

                    <!-- Status do cliente -->
                    <div
                      class="d-flex align-center mb-3"
                      v-if="
                        clientInfo.falecimento &&
                        clientInfo.falecimento !== '1900-01-01'
                      "
                    >
                      <div class="subtitle-1 font-weight-medium">Status:</div>
                      <v-chip
                        :color="
                          clientInfo.falecimento &&
                          clientInfo.falecimento !== '1900-01-01'
                            ? 'error'
                            : 'success'
                        "
                        small
                        class="ml-2"
                        :text-color="
                          clientInfo.falecimento &&
                          clientInfo.falecimento !== '1900-01-01'
                            ? 'white'
                            : ''
                        "
                      >
                        {{
                          clientInfo.falecimento &&
                          clientInfo.falecimento !== "1900-01-01"
                            ? "Falecido"
                            : "Ativo"
                        }}
                      </v-chip>
                      <div
                        v-if="
                          clientInfo.falecimento &&
                          clientInfo.falecimento !== '1900-01-01'
                        "
                        class="ml-2 caption"
                      >
                        Data: {{ formatDate(clientInfo.falecimento) }}
                      </div>
                    </div>
                  </div>
                  <v-expansion-panels v-model="panel">
                    <v-expansion-panel class="expansion-panel">
                      <v-expansion-panel-header>
                        <!-- Contratos -->
                        <div class="pt-0 subtitle-1 font-weight-medium">
                          Contratos ({{
                            clientInfo.contratos
                              ? clientInfo.contratos.length
                              : 0
                          }})
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content expand>
                        <!-- Lista de contratos -->
                        <div class="pt-0">
                          <v-expansion-panels>
                            <v-expansion-panel
                              v-for="contrato in clientInfo.contratos"
                              :key="contrato.id"
                              class="expansion-panel"
                            >
                              <v-expansion-panel-header>
                                <div>
                                  <div class="font-weight-medium">
                                    {{ contrato.tipo }}
                                  </div>
                                  <div class="caption">
                                    <v-chip
                                      x-small
                                      :color="
                                        contrato.status === 'Ativo'
                                          ? 'success'
                                          : 'red'
                                      "
                                      class="mr-1"
                                    >
                                      {{ contrato.status }}
                                    </v-chip>
                                    Ref: {{ contrato.referencia }}
                                  </div>
                                </div>
                              </v-expansion-panel-header>

                              <v-expansion-panel-content expand>
                                <v-divider></v-divider>

                                <!-- Detalhes simples -->
                                <div class="py-3">
                                  <div>
                                    <strong>Empresa:</strong>
                                    {{ contrato.empresa }}
                                  </div>
                                  <div>
                                    <strong>Data:</strong>
                                    {{ formatDate(contrato.dataContrato) }}
                                  </div>

                                  <!-- Informações de LTV -->
                                  <div v-if="contrato.ltv" class="mt-4">
                                    <v-divider class="my-1"></v-divider>
                                    <div class="subtitle-2 mb-1">
                                      Informações de LTV
                                    </div>

                                    <v-row dense class="py-2">
                                      <v-col cols="12" sm="6" class="py-0">
                                        <div class="caption">
                                          <strong>Severidade:</strong>
                                          {{ contrato.ltv.severidade }}
                                        </div>
                                      </v-col>
                                      <v-col cols="12" sm="6" class="py-0">
                                        <div class="caption">
                                          <strong>LTV:</strong>
                                          {{ contrato.ltv.ltv?.toFixed(4) }}
                                        </div>
                                      </v-col>
                                      <v-col cols="12" sm="6" class="py-0">
                                        <div class="caption">
                                          <strong>Débito Cliente:</strong> R$
                                          {{
                                            contrato.ltv.debitoCliente?.toFixed(
                                              2,
                                            )
                                          }}
                                        </div>
                                      </v-col>
                                      <v-col cols="12" sm="6" class="py-0">
                                        <div class="caption">
                                          <strong>% Aplicado:</strong>
                                          {{ contrato.ltv.percentualAplicado }}
                                        </div>
                                      </v-col>
                                      <v-col cols="12" sm="6" class="py-0">
                                        <div class="caption">
                                          <strong>Desconto:</strong> R$
                                          {{
                                            contrato.ltv.desconto?.toFixed(2)
                                          }}
                                        </div>
                                      </v-col>
                                      <v-col cols="12" sm="6" class="py-0">
                                        <div class="caption">
                                          <strong>Valor Final:</strong> R$
                                          {{
                                            contrato.ltv.valorFinal?.toFixed(2)
                                          }}
                                        </div>
                                      </v-col>
                                      <v-col cols="12" class="py-0">
                                        <div class="caption">
                                          <strong>Oferta:</strong>
                                          {{ contrato.ltv.oferta }}
                                        </div>
                                      </v-col>
                                    </v-row>
                                  </div>
                                </div>

                                <v-divider></v-divider>

                                <!-- Parcelas -->
                                <v-tabs
                                  v-model="activeTab"
                                  background-color="transparent"
                                  color="primary"
                                  grow
                                  class="mt-3"
                                >
                                  <v-tab>
                                    <v-icon left small
                                      >mdi-cash-multiple</v-icon
                                    >
                                    Parcelas
                                  </v-tab>
                                  <v-tab>
                                    <v-icon left small>mdi-history</v-icon>
                                    Interações
                                  </v-tab>
                                </v-tabs>
                                <v-tabs-items v-model="activeTab">
                                  <v-tab-item>
                                    <!-- Parcelas -->
                                    <div class="pa-0 pt-4">
                                      <div
                                        v-if="!contrato.parcelas?.length"
                                        class="caption text-center pa-4"
                                      >
                                        <v-icon large color="grey lighten-1"
                                          >mdi-cash-remove</v-icon
                                        >
                                        <div class="mt-2">
                                          Nenhuma parcela em aberta encontrada
                                        </div>
                                      </div>

                                      <v-data-table
                                        v-else
                                        :headers="[]"
                                        :items="contrato.parcelas"
                                        hide-default-header
                                        :items-per-page="5"
                                        class="elevation-0 mt-2"
                                        :footer-props="{
                                          'items-per-page-options': [5],
                                          'show-current-page': true,
                                          'show-first-last-page': true,
                                        }"
                                      >
                                        <template
                                          v-slot:item="{ item: parcela }"
                                        >
                                          <tr>
                                            <td>
                                              <div class="py-2 border-bottom">
                                                <div
                                                  class="caption d-flex justify-space-between"
                                                >
                                                  <div class="subtitle-2">
                                                    {{
                                                      formatDateBR(
                                                        parcela.vencimento,
                                                      )
                                                    }}
                                                  </div>
                                                  <v-chip
                                                    small
                                                    :color="
                                                      getVencimentoColor(
                                                        parcela.vencimento,
                                                        parcela.status,
                                                      )
                                                    "
                                                    :text-color="
                                                      getVencimentoColor(
                                                        parcela.vencimento,
                                                        parcela.status,
                                                      ) === 'error'
                                                        ? 'white'
                                                        : ''
                                                    "
                                                  >
                                                    {{
                                                      getVencimentoStatus(
                                                        parcela.vencimento,
                                                        parcela.status,
                                                      )
                                                    }}
                                                  </v-chip>
                                                </div>
                                                <div
                                                  class="caption d-flex justify-space-between align-center mt-2"
                                                >
                                                  <div
                                                    class="d-flex align-center"
                                                  >
                                                    <div
                                                      class="caption"
                                                      style="width: 9rem"
                                                    >
                                                      Ref:
                                                      {{
                                                        parcela.identificacao
                                                      }}
                                                    </div>
                                                    <v-btn
                                                      v-if="parcela.idDocumento"
                                                      x-small
                                                      color="primary"
                                                      class="ml-2"
                                                      @click="
                                                        abrirDialogSelecaoFormaPagamento(
                                                          parcela.idDocumento,
                                                        )
                                                      "
                                                      :loading="
                                                        loadingFormaPagamento ===
                                                        parcela.idDocumento
                                                      "
                                                      title="Pagar"
                                                      :disabled="
                                                        !isCurrentUserAttendant &&
                                                        !isCurrentUserParticipant
                                                      "
                                                    >
                                                      <v-icon left small
                                                        >mdi-credit-card</v-icon
                                                      >
                                                      Pagar
                                                    </v-btn>
                                                  </div>

                                                  <div class="subtitle-2">
                                                    R$
                                                    {{
                                                      parcela.valor
                                                        ?.toFixed(2)
                                                        .replace(".", ",")
                                                    }}
                                                  </div>
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        </template>
                                      </v-data-table>
                                    </div>
                                  </v-tab-item>

                                  <v-tab-item>
                                    <!-- Interações -->
                                    <div class="pa-0 pt-4">
                                      <div
                                        v-if="!contrato.interacoes?.length"
                                        class="caption text-center pa-4"
                                      >
                                        <v-icon large color="grey lighten-1"
                                          >mdi-message-text-outline</v-icon
                                        >
                                        <div class="mt-2">
                                          Nenhuma interação encontrada
                                        </div>
                                      </div>

                                      <v-data-table
                                        v-else
                                        :headers="[]"
                                        :items="contrato.interacoes"
                                        hide-default-header
                                        :items-per-page="5"
                                        class="elevation-0 mt-2"
                                        :footer-props="{
                                          'items-per-page-options': [5],
                                          'show-current-page': true,
                                          'show-first-last-page': true,
                                        }"
                                      >
                                        <template v-slot:item="{ item: i }">
                                          <tr>
                                            <td>
                                              <div class="py-2 border-bottom">
                                                <div class="caption">
                                                  {{ i.assunto }}
                                                </div>

                                                <div class="caption">
                                                  {{ i.descricao }}
                                                </div>
                                                <div
                                                  class="caption d-flex justify-space-between mt-2"
                                                >
                                                  <v-chip small>{{
                                                    i.contrato
                                                  }}</v-chip>
                                                  {{
                                                    formatDateBR(
                                                      i.dataInteracao,
                                                    )
                                                  }}
                                                </div>
                                              </div>
                                            </td>
                                          </tr>
                                        </template>
                                      </v-data-table>
                                    </div>
                                  </v-tab-item>
                                  <v-tab-item>
                                    <!-- Interações -->
                                    <div class="pa-0 pt-4">
                                      <div
                                        v-if="!contrato.protocols?.length"
                                        class="caption text-center pa-4"
                                      >
                                        <v-icon large color="grey lighten-1"
                                          >mdi-message-text-outline</v-icon
                                        >
                                        <div class="mt-2">
                                          Nenhuma interação encontrada
                                        </div>
                                      </div>
                                    </div>
                                  </v-tab-item>
                                </v-tabs-items>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <v-divider class="my-3"></v-divider>
                  <v-expansion-panels>
                    <v-expansion-panel class="expansion-panel">
                      <v-expansion-panel-header>
                        <div class="pt-0 subtitle-1 font-weight-medium">
                          Protocolos ({{
                            clientInfo.protocolos
                              ? clientInfo.protocolos.length
                              : 0
                          }})
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content expand>
                        <div class="pt-0">
                          <v-data-table
                            :headers="[]"
                            :items="clientInfo.protocolos"
                            hide-default-header
                            :items-per-page="5"
                            class="elevation-0 mt-2"
                            :footer-props="{
                              'items-per-page-options': [5],
                              'show-current-page': true,
                              'show-first-last-page': true,
                            }"
                          >
                            <template v-slot:item="{ item: i }">
                              <tr>
                                <td>
                                  <div class="py-2 border-bottom">
                                    <div
                                      class="d-flex justify-space-between align-center"
                                    >
                                      <!-- Texto -->
                                      <div>
                                        <div
                                          class="text-body-2 font-weight-medium"
                                        >
                                          Protocolo: {{ i.numeroProtocolo }}
                                        </div>

                                        <div class="caption">
                                          Responsável:
                                          {{ i.nomeAtendente || "—" }}
                                        </div>
                                      </div>

                                      <!-- Botão visualizar -->
                                      <v-btn
                                        small
                                        text
                                        color="primary"
                                        @click="abrirProtocolo(i)"
                                      >
                                        <v-icon small>mdi-eye</v-icon>
                                      </v-btn>
                                    </div>

                                    <!-- Status + Data -->
                                    <div
                                      class="caption d-flex justify-space-between align-center mt-2"
                                    >
                                      <v-chip
                                        small
                                        dark
                                        :color="
                                          i.status === 'FECHADO'
                                            ? 'green'
                                            : 'warning'
                                        "
                                      >
                                        {{
                                          i.status === "FECHADO"
                                            ? "Concluído"
                                            : "Aberto"
                                        }}
                                      </v-chip>

                                      {{ formatDateTimeBR(i.dataAbertura) }}
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            </template>
                          </v-data-table>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                  <!-- Protocolos -->
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>

    <!-- Diálogo para transferência de atendimento -->
    <v-dialog
      v-model="showTransferDialog"
      max-width="1000"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline primary white--text">
          Transferir Atendimento
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert type="info" outlined class="mb-6 px-2 py-1">
            Selecione um colaborador para transferir o atendimento do protocolo
            <strong>{{ protocoloSelecionado?.numeroProtocolo }}</strong>
          </v-alert>
          <v-text-field
            v-model="searchColaborador"
            append-icon="mdi-magnify"
            label="Buscar colaborador"
            outlined
            dense
            clearable
            class="mb-3"
          ></v-text-field>
          <v-data-table
            :headers="colaboradoresHeaders"
            :items="colaboradores"
            :search="searchColaborador"
            :loading="loadingColaboradores"
            item-key="id"
            single-select
            show-select
            v-model="selectedColaboradores"
            :items-per-page="5"
            :footer-props="{
              'items-per-page-options': [5, 10, 15],
              'items-per-page-text': 'Itens por página:',
              'show-current-page': true,
            }"
            class="elevation-0 rounded"
            :no-data-text="
              loadingColaboradores
                ? 'Carregando colaboradores...'
                : 'Nenhum colaborador encontrado'
            "
          ></v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="
              showTransferDialog = false;
              selectedColaboradores = [];
              transferringAttendance = false;
              searchColaborador = '';
            "
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="executarTransferencia"
            :disabled="!selectedColaboradores.length || transferringAttendance"
            :loading="transferringAttendance"
          >
            <v-icon left small>mdi-check</v-icon>
            Transferir Atendimento
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para transferência de fila -->
    <v-dialog
      v-model="showTransferFilaDialog"
      max-width="600"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline info white--text">
          <v-icon left color="white">mdi-swap-horizontal</v-icon>
          Transferir Fila
        </v-card-title>

        <v-card-text class="pt-4">
          <v-alert type="info" outlined class="mb-4">
            Selecione a fila de destino para transferir o protocolo
            <strong>{{ protocoloSelecionado?.numeroProtocolo }}</strong>
          </v-alert>

          <div class="mb-3">
            <div class="text--secondary mb-2">Fila Atual:</div>
            <v-chip color="primary" outlined>
              <v-icon left small>mdi-folder</v-icon>
              {{ filaAtualProtocolo || "Não definida" }}
            </v-chip>
          </div>

          <v-divider class="my-4"></v-divider>

          <div class="mb-3">
            <div class="text--secondary mb-2">Selecione a nova fila:</div>
          </div>

          <v-radio-group v-model="filaDestinoSelecionada" class="mt-0">
            <v-radio
              v-for="fila in filasDisponiveis"
              :key="fila.id"
              :label="fila.nomeFila"
              :value="fila.id"
              color="primary"
            >
              <template v-slot:label>
                <div class="d-flex align-center">
                  <v-icon left small color="primary">mdi-folder-outline</v-icon>
                  <span style="color: black">{{ fila.nomeFila }}</span>
                </div>
              </template>
            </v-radio>
          </v-radio-group>

          <v-alert
            v-if="!filasDisponiveis.length"
            type="warning"
            outlined
            dense
            class="mt-3"
          >
            Nenhuma fila disponível para transferência.
          </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="fecharDialogTransferenciaFila"
            :disabled="transferindoFila"
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-btn
            color="info"
            @click="executarTransferenciaFila"
            :disabled="!filaDestinoSelecionada || transferindoFila"
            :loading="transferindoFila"
          >
            <v-icon left small>mdi-check</v-icon>
            Transferir Fila
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para adicionar participante -->
    <v-dialog
      v-model="showParticipantDialog"
      max-width="1000"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline success white--text">
          Adicionar Participante
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert type="info" outlined class="mb-6 px-2 py-1">
            Selecione um colaborador para adicionar como participante no
            protocolo
            <strong>{{ protocoloSelecionado?.numeroProtocolo }}</strong>
          </v-alert>
          <v-text-field
            v-model="searchColaborador"
            append-icon="mdi-magnify"
            label="Buscar colaborador"
            outlined
            dense
            clearable
            class="mb-3"
          ></v-text-field>
          <v-data-table
            :headers="colaboradoresHeaders"
            :items="colaboradores"
            :search="searchColaborador"
            :loading="loadingColaboradores"
            item-key="id"
            single-select
            show-select
            v-model="selectedColaboradores"
            :items-per-page="5"
            :footer-props="{
              'items-per-page-options': [5, 10, 15],
              'items-per-page-text': 'Itens por página:',
              'show-current-page': true,
            }"
            class="elevation-0 rounded"
            :no-data-text="
              loadingColaboradores
                ? 'Carregando colaboradores...'
                : 'Nenhum colaborador encontrado'
            "
          ></v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn
            color="grey darken-1"
            text
            @click="
              showParticipantDialog = false;
              selectedColaboradores = [];
              addingParticipant = false;
              searchColaborador = '';
            "
          >
            <v-icon left small>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            @click="adicionarParticipante"
            :disabled="!selectedColaboradores.length || addingParticipant"
            :loading="addingParticipant"
          >
            <v-icon left small>mdi-check</v-icon>
            Adicionar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para editar contato do cliente -->
    <v-dialog v-model="showEditClientContactDialog" max-width="500">
      <v-card>
        <v-card-title class="headline">
          Editar contato do cliente
        </v-card-title>
        <v-card-text>
          <v-form ref="editClientContactFormRef">
            <v-text-field
              label="ID do Cliente"
              :value="editClientContactForm.idCliente"
              outlined
              dense
              readonly
              disabled
              class="mb-4"
            ></v-text-field>
            <v-text-field
              label="Celular"
              v-model="editClientContactForm.celular"
              v-mask="'(##) #####-####'"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              label="Telefone"
              v-model="editClientContactForm.telefone"
              v-mask="'(##) ####-####'"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              label="E-mail"
              v-model="editClientContactForm.email"
              outlined
              dense
            ></v-text-field>
            <v-textarea
              label="Endereço"
              :value="editClientContactForm.endereco"
              outlined
              dense
              readonly
              disabled
              auto-grow
              rows="2"
              class="mt-2"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="showEditClientContactDialog = false"
            :disabled="updatingClientContact"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="atualizarContatoCliente"
            :loading="updatingClientContact"
            :disabled="updatingClientContact"
          >
            Atualizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo para adicionar interação do cliente -->
    <v-dialog v-model="showAddClientInteractionDialog" max-width="500">
      <v-card>
        <v-card-title class="headline"> Adicionar interação </v-card-title>
        <v-card-text>
          <v-form ref="addClientInteractionFormRef">
            <v-select
              label="Tipo de interação"
              v-model="addClientInteractionForm.tipo"
              :items="interactionTypes"
              item-text="label"
              item-value="value"
              outlined
              dense
            ></v-select>
            <v-select
              label="Contrato"
              v-model="addClientInteractionForm.contratoId"
              :items="availableClientContracts"
              item-text="label"
              item-value="id"
              outlined
              dense
              class="mt-3"
            ></v-select>
            <v-textarea
              label="Descrição da interação"
              v-model="addClientInteractionForm.descricao"
              outlined
              dense
              auto-grow
              rows="4"
              counter="255"
              maxlength="255"
              class="mt-3"
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="showAddClientInteractionDialog = false"
            :disabled="savingClientInteraction"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="salvarInteracaoCliente"
            :loading="savingClientInteraction"
            :disabled="savingClientInteraction"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de resultado da atualização de contato -->
    <v-dialog v-model="showClientUpdateResultDialog" max-width="400">
      <v-card>
        <v-card-title class="headline"> Confirmado </v-card-title>
        <v-card-text>
          {{ clientUpdateResultMessage }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="showClientUpdateResultDialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de resultado da interação do cliente -->
    <v-dialog v-model="showClientInteractionResultDialog" max-width="400">
      <v-card>
        <v-card-title class="headline"> Confirmado </v-card-title>
        <v-card-text>
          {{ clientInteractionResultMessage }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="showClientInteractionResultDialog = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Seleção de Forma de Pagamento -->
    <v-dialog
      v-model="showSelecaoFormaPagamentoDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-overlay :value="loadingFormaPagamento !== null" absolute>
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
          ></v-progress-circular>
          <div class="mt-4 white--text">Processando...</div>
        </v-overlay>
        <v-card-title class="headline primary white--text">
          <v-icon color="white" class="mr-2">mdi-credit-card</v-icon>
          Selecionar Forma de Pagamento
        </v-card-title>
        <v-card-text class="pt-4">
          <p class="body-1 mb-4">Escolha a forma de pagamento desejada:</p>
          <v-list>
            <v-list-item
              @click="selecionarFormaPagamento('PDF Boleto')"
              :disabled="loadingFormaPagamento !== null"
              class="mb-2"
              style="
                border: 1px solid #e0e0e0;
                border-radius: 4px;
                cursor: pointer;
              "
            >
              <v-list-item-icon>
                <v-icon color="primary">mdi-file-pdf-box</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>PDF Boleto</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="selecionarFormaPagamento('Pix')"
              :disabled="loadingFormaPagamento !== null"
              class="mb-2"
              style="
                border: 1px solid #e0e0e0;
                border-radius: 4px;
                cursor: pointer;
              "
            >
              <v-list-item-icon>
                <v-icon color="primary">mdi-qrcode</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Pix</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="selecionarFormaPagamento('Link de Pagamento')"
              :disabled="loadingFormaPagamento !== null"
              class="mb-2"
              style="
                border: 1px solid #e0e0e0;
                border-radius: 4px;
                cursor: pointer;
              "
            >
              <v-list-item-icon>
                <v-icon color="primary">mdi-link</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Link de Pagamento</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="selecionarFormaPagamento('Código de Barras')"
              :disabled="loadingFormaPagamento !== null"
              class="mb-2"
              style="
                border: 1px solid #e0e0e0;
                border-radius: 4px;
                cursor: pointer;
              "
            >
              <v-list-item-icon>
                <v-icon color="primary">mdi-barcode</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Código de Barras</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            text
            @click="closeSelecaoFormaPagamentoDialog"
            :disabled="loadingFormaPagamento !== null"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Forma de Pagamento -->
    <v-dialog
      v-model="showFormaPagamentoDialog"
      max-width="800"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline primary white--text">
          Forma de Pagamento
        </v-card-title>
        <v-card-text class="pt-4">
          <p v-if="formaPagamentoResponse" class="body-1">
            {{ formaPagamentoResponse }}
          </p>
          <div v-if="formaPagamentoLink">
            <p class="body-2 mb-2">Link gerado:</p>
            <v-text-field
              :value="formaPagamentoLink"
              readonly
              outlined
              dense
              class="mb-3"
            ></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <template v-if="formaPagamentoLink">
            <v-btn
              color="success"
              @click="enviarMensagemFormaPagamento"
              :loading="sendingMessage"
              class="mr-2"
            >
              <v-icon left small>mdi-send</v-icon>
              Enviar Mensagem
            </v-btn>
            <v-btn color="info" @click="copiarLinkFormaPagamento" class="mr-2">
              <v-icon left small>mdi-content-copy</v-icon>
              Copiar
            </v-btn>
          </template>
          <template
            v-else-if="
              formaPagamentoResponse &&
              formaPagamentoResponse !==
                'Esta forma de pagamento não está habilitada para este documento.'
            "
          >
            <v-btn color="info" @click="copiarTextoFormaPagamento" class="mr-2">
              <v-icon left small>mdi-content-copy</v-icon>
              Copiar
            </v-btn>
            <v-btn
              color="success"
              @click="enviarMensagemTextoFormaPagamento"
              :loading="sendingMessage"
              class="mr-2"
            >
              <v-icon left small>mdi-send</v-icon>
              Enviar Mensagem
            </v-btn>
          </template>
          <v-btn color="primary" @click="closeFormaPagamentoDialog">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Boleto PDF -->
    <v-dialog
      v-model="showBoletoPdfDialog"
      max-width="900"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title class="headline primary white--text">
          <v-icon left color="white">mdi-file-pdf-box</v-icon>
          Boleto Gerado
        </v-card-title>
        <v-card-text class="pt-4">
          <div v-if="boletoPdfUrl" style="height: 600px">
            <iframe
              :src="boletoPdfUrl"
              width="100%"
              height="100%"
              frameborder="0"
              style="border: 1px solid #ddd; border-radius: 4px"
            ></iframe>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="closeBoletoPdfDialog" outlined>
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            @click="enviarBoletoParaCliente"
            :loading="sendingBoleto"
            class="mr-2"
          >
            <v-icon left small>mdi-send</v-icon>
            Enviar para Cliente
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Mensagens do Protocolo -->
    <v-dialog
      v-model="showProtocolMessagesDialog"
      max-width="800"
      scrollable
      persistent
    >
      <v-card>
        <v-card-title class="headline primary white--text">
          Mensagens do Protocolo
          {{ protocolMessagesData ? protocolMessagesData.numeroProtocolo : "" }}
        </v-card-title>

        <v-card-text class="pt-4" style="height: 500px; overflow-y: auto">
          <!-- Loading -->
          <div v-if="protocolMessagesLoading" class="text-center py-5">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
            <div class="mt-3">Carregando mensagens...</div>
          </div>

          <!-- Sem mensagens -->
          <div
            v-else-if="selectedProtocolMessages.length === 0"
            class="text-center py-5"
          >
            <v-alert type="info" outlined>
              Nenhuma mensagem encontrada para este protocolo.
            </v-alert>
          </div>

          <!-- Mensagens -->
          <div v-else class="chat-container">
            <div
              v-for="message in selectedProtocolMessages"
              :key="message.id"
              :class="[
                'message-bubble mb-2 pa-2',
                message.direcao === 'OUTBOUND'
                  ? 'outgoing-message'
                  : 'incoming-message',
              ]"
            >
              <!-- Texto -->
              <div v-if="message.tipo === 'text'">
                {{ message.conteudo }}
              </div>

              <!-- vCard -->
              <div
                v-else-if="message.tipo === 'vcard'"
                class="message-media-card"
              >
                <div class="media-card-header">
                  <v-icon color="primary" small
                    >mdi-card-account-details</v-icon
                  >
                  <span class="media-card-label">Cartão de contato</span>
                </div>
                <div class="media-card-body">
                  <pre class="vcard-content">{{ message.conteudo }}</pre>
                </div>
              </div>

              <!-- Geo -->
              <div
                v-else-if="message.tipo === 'geo'"
                class="message-media-card"
              >
                <div class="media-card-header">
                  <v-icon color="success" small>mdi-map-marker</v-icon>
                  <span class="media-card-label">Localização</span>
                </div>
                <div class="media-card-body">
                  <div class="geo-content">
                    {{ message.conteudo || "Localização compartilhada" }}
                  </div>
                  <a
                    v-if="getMapsUrl(message.conteudo)"
                    :href="getMapsUrl(message.conteudo)"
                    target="_blank"
                    class="geo-link"
                  >
                    <v-icon x-small>mdi-open-in-new</v-icon>
                    Ver no mapa
                  </a>
                </div>
              </div>

              <!-- Chamada perdida / unsupported / unknown -->
              <div
                v-else-if="
                  ['missing_call', 'unsupported', 'unknown'].includes(
                    message.tipo,
                  )
                "
                class="message-media-card message-media-card--subtle"
              >
                <div class="media-card-header">
                  <v-icon color="grey" small>
                    {{
                      message.tipo === "missing_call"
                        ? "mdi-phone-missed"
                        : "mdi-help-circle-outline"
                    }}
                  </v-icon>
                  <span class="media-card-label">{{
                    message.tipo === "missing_call"
                      ? "Chamada perdida"
                      : message.tipo === "unsupported"
                      ? "Tipo não suportado"
                      : "Mensagem desconhecida"
                  }}</span>
                </div>
                <div v-if="message.conteudo" class="media-card-body">
                  {{ message.conteudo }}
                </div>
              </div>

              <!-- BOT -->
              <div
                v-else-if="message.tipo === 'BOT'"
                class="message-media-card"
              >
                <div class="media-card-header">
                  <v-icon color="secondary" small>mdi-robot</v-icon>
                  <span class="media-card-label">BOT</span>
                </div>
                <div class="media-card-body">
                  {{ message.conteudo || "Mensagem do BOT" }}
                </div>
              </div>

              <!-- Template WABA -->
              <div
                v-else-if="message.tipo === 'wapi_template'"
                class="message-media-card"
              >
                <div class="media-card-header">
                  <v-icon color="secondary" small
                    >mdi-format-list-bulleted-type</v-icon
                  >
                  <span class="media-card-label">Template</span>
                </div>
                <div class="media-card-body">
                  {{ message.conteudo || "Mensagem template" }}
                </div>
              </div>

              <!-- Mídia com preview -->
              <div
                v-else-if="message.contentUri && hasMediaPreview(message)"
                class="message-media-card"
              >
                <div class="media-card-header">
                  <v-icon small :color="getTipoIconColor(message.tipo)">
                    {{ getTipoIcon(message.tipo) }}
                  </v-icon>
                  <span class="media-card-label">{{
                    getTipoLabel(message.tipo)
                  }}</span>
                  <span
                    v-if="getFileName(message.contentUri) !== 'arquivo'"
                    class="media-card-filename"
                  >
                    {{ getFileName(message.contentUri) }}
                  </span>
                </div>
                <div class="media-card-preview">
                  <img
                    v-if="message.tipo === 'image'"
                    :src="getMediaUrl(message.contentUri)"
                    alt="Imagem"
                    class="media-preview-img"
                    @click="abrirEmNovaAba(getMediaUrl(message.contentUri))"
                  />
                  <video
                    v-else-if="message.tipo === 'video'"
                    :src="getMediaUrl(message.contentUri)"
                    controls
                    class="media-preview-video"
                  />
                  <div
                    v-else-if="message.tipo === 'audio'"
                    class="media-preview-audio"
                  >
                    <audio :src="getMediaUrl(message.contentUri)" controls />
                  </div>
                  <iframe
                    v-else-if="
                      message.tipo === 'document' &&
                      isPdfDocument(message.contentUri)
                    "
                    :src="getMediaUrl(message.contentUri)"
                    class="media-preview-iframe"
                    title="Visualizar PDF"
                  />
                </div>
                <div class="media-card-actions">
                  <v-btn
                    small
                    color="primary"
                    :href="message.contentUri"
                    target="_blank"
                    :download="getFileName(message.contentUri)"
                    text
                    class="pa-0"
                  >
                    <v-icon left small>mdi-download</v-icon>
                    Baixar
                  </v-btn>
                </div>
              </div>

              <!-- Documento/arquivo sem preview -->
              <div
                v-else-if="message.contentUri && message.tipo !== 'text'"
                class="message-media-card"
              >
                <div class="media-card-header">
                  <v-icon small color="grey">
                    {{ getTipoIcon(message.tipo) }}
                  </v-icon>
                  <span class="media-card-label">{{
                    getTipoLabel(message.tipo)
                  }}</span>
                  <span class="media-card-filename">
                    {{ getFileName(message.contentUri) }}
                  </span>
                </div>
                <div class="media-card-actions media-card-actions--standalone">
                  <v-btn
                    small
                    color="primary"
                    :href="message.contentUri"
                    target="_blank"
                    :download="getFileName(message.contentUri)"
                    outlined
                  >
                    <v-icon left small>mdi-download</v-icon>
                    Baixar arquivo
                  </v-btn>
                </div>
              </div>

              <!-- Fallback -->
              <div v-else class="message-media-card message-media-card--subtle">
                <div class="media-card-body">
                  {{ message.conteudo || "(arquivo ou mídia sem conteúdo)" }}
                </div>
              </div>

              <div class="message-time">
                {{ formatarDataMensagem(message.dataEnvio) }}
              </div>
              <div
                v-if="message.direcao === 'OUTBOUND' && message.status !== null"
                class="caption text-right mt-1"
                :class="{
                  'success--text': message.status === 3,
                  'info--text': message.status === 2,
                  'grey--text':
                    message.status !== 2 &&
                    message.status !== 3 &&
                    message.status !== -2,
                  'error--text': message.status === -2,
                }"
              >
                <template v-if="message.status === 3">
                  <v-icon x-small color="success">mdi-check-all</v-icon>
                  <span class="ml-1">Lido</span>
                </template>
                <template v-else-if="message.status === 2">
                  <v-icon x-small color="info">mdi-check-all</v-icon>
                  <span class="ml-1">Entregue</span>
                </template>
                <template v-else-if="message.status === -2">
                  <v-icon x-small color="error">mdi-alert-circle</v-icon>
                  <span class="ml-1">Erro ao enviar</span>
                </template>
                <template
                  v-else-if="message.status === 0 || message.status === 1"
                >
                  <v-icon x-small color="grey">mdi-check</v-icon>
                  <span class="ml-1">Enviada</span>
                </template>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeProtocolMessagesDialog">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Confirmação para Finalizar Protocolo -->
    <v-dialog
      v-model="showFinalizeProtocolConfirmDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="headline">
          Confirmar finalização de protocolo
        </v-card-title>
        <v-card-text>
          Tem certeza que deseja finalizar este protocolo e encerrar o
          atendimento?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="cancelFinalizeProtocol">
            Cancelar
          </v-btn>
          <v-btn color="red darken-1" text @click="executeFinalizeProtocol">
            Finalizar Protocolo
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Confirmação para Remover Participante -->
    <v-dialog
      v-model="showRemoveParticipantConfirmDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="headline amber darken-2 white--text">
          <v-icon color="white" class="mr-2">mdi-account-minus</v-icon>
          Confirmar remoção de participante
        </v-card-title>
        <v-card-text class="pt-4">
          Tem certeza que deseja remover o participante deste atendimento?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="cancelRemoveParticipant">
            Cancelar
          </v-btn>
          <v-btn color="amber darken-3" text @click="executeRemoveParticipant">
            Remover Participante
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de Confirmação para Sair do Atendimento -->
    <v-dialog
      v-model="showExitAttendanceConfirmDialog"
      max-width="500"
      persistent
    >
      <v-card>
        <v-card-title class="headline warning white--text">
          <v-icon color="white" class="mr-2">mdi-exit-to-app</v-icon>
          Confirmar saída do atendimento
        </v-card-title>
        <v-card-text class="pt-4">
          Tem certeza que deseja sair deste atendimento atual?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="cancelExitAttendance">
            Cancelar
          </v-btn>
          <v-btn color="warning" text @click="executeExitAttendance">
            Sair do Atendimento
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de arquivo enviado -->
    <v-dialog v-model="showFileUrlDialog" max-width="500">
      <v-card>
        <v-card-title class="headline primary white--text">
          <v-icon left color="white">mdi-check-circle</v-icon>
          Envio de Arquivo
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert type="success" outlined class="mb-0">
            O arquivo foi enviado com sucesso.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="closeFileUrlDialog"> Fechar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de gravação de áudio -->
    <v-dialog v-model="dialogAudio" max-width="500" persistent>
      <v-card>
        <v-card-title class="headline primary white--text">
          <span>{{
            isRecording ? "Gravando áudio..." : "Gravar mensagem de áudio"
          }}</span>
        </v-card-title>

        <v-card-text class="pa-4 text-center">
          <!-- Solicitar permissão -->
          <div v-if="permissaoMicrofone === null" class="my-4">
            <v-icon size="64" color="#4caf50" class="mb-4"
              >mdi-microphone</v-icon
            >
            <div class="title mb-2">Permissão para usar o microfone</div>
            <div class="subtitle-1 grey--text mb-4">
              Para gravar áudio, precisamos da sua permissão para acessar o
              microfone.
            </div>
            <v-btn
              color="#4caf50"
              @click="solicitarPermissaoMicrofone"
              :loading="solicitandoPermissao"
            >
              <v-icon left>mdi-microphone</v-icon>
              Permitir acesso
            </v-btn>
          </div>

          <!-- Permissão negada -->
          <div v-else-if="permissaoMicrofone === false" class="my-4">
            <v-icon size="64" color="red" class="mb-4"
              >mdi-microphone-off</v-icon
            >
            <div class="title mb-2">Permissão negada</div>
            <div class="subtitle-1 grey--text mb-4">
              Você não permitiu o acesso ao microfone. Para gravar áudio, é
              necessário permitir o acesso nas configurações do seu navegador.
            </div>
          </div>

          <!-- Gravador de áudio -->
          <div v-else class="audio-recorder-container">
            <div
              class="audio-visualizer mb-4"
              :class="{ 'is-recording': isRecording }"
            >
              <div class="time-counter">
                {{ formatAudioTime(audioDuration) }}
              </div>
              <div class="wave-container">
                <div class="wave" v-for="n in 5" :key="n"></div>
              </div>
            </div>

            <!-- Botões de controle -->
            <div class="audio-controls">
              <!-- Botão de gravação -->
              <v-btn
                v-if="!isRecording && !audioBlob"
                fab
                color="#4caf50"
                @click="iniciarGravacao"
                class="mx-2"
              >
                <v-icon>mdi-microphone</v-icon>
              </v-btn>

              <!-- Botão de parar -->
              <v-btn
                v-if="isRecording"
                fab
                color="red"
                @click="pararGravacao"
                class="mx-2"
              >
                <v-icon>mdi-stop</v-icon>
              </v-btn>

              <!-- Player de áudio (após gravar) -->
              <audio
                v-if="audioURL && !isRecording"
                controls
                :src="audioURL"
                class="audio-preview-player mb-3"
              ></audio>

              <!-- Botões após gravar -->
              <div
                v-if="audioBlob && !isRecording"
                class="d-flex justify-center mt-3"
              >
                <v-btn
                  text
                  color="error"
                  @click="descartarAudio"
                  class="mx-2"
                  small
                >
                  <v-icon left>mdi-delete</v-icon>
                  Descartar
                </v-btn>

                <v-btn
                  color="#4caf50"
                  @click="enviarAudio"
                  :loading="enviandoAudio"
                  class="mx-2"
                  small
                >
                  <v-icon left>mdi-send</v-icon>
                  Enviar
                </v-btn>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="#4caf50" @click="fecharDialogAudio"
            >Cancelar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de anexo de arquivo -->
    <v-dialog v-model="showFileAttachmentDialog" max-width="500">
      <v-card>
        <v-card-title class="headline primary white--text">
          Anexar arquivo
        </v-card-title>
        <v-card-text class="pt-4">
          <v-alert v-if="fileError" type="error" outlined class="mb-4">
            {{ fileError }}
          </v-alert>

          <v-file-input
            v-model="selectedFile"
            label="Selecione um arquivo"
            outlined
            dense
            show-size
            counter
            @change="onFileSelected"
          ></v-file-input>

          <div v-if="selectedFile" class="mt-2">
            <p class="body-2 mb-1">
              <strong>Arquivo:</strong> {{ selectedFileName }}
            </p>
            <p class="body-2">
              <strong>Tamanho:</strong> {{ formatFileSize(selectedFileSize) }}
            </p>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="closeFileAttachmentDialog">
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            :disabled="!selectedFile || sendingFile"
            :loading="sendingFile"
            @click="sendAttachedFile"
          >
            <v-icon left>mdi-send</v-icon>
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn icon small v-bind="attrs" @click="snackbar.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import FiltroEmpresa from "./components/FiltroEmpresaChat.vue";
import WazzupService from "@/services/wazzup";
import Sonax from "@/services/sonax";
import UsuarioService from "@/services/usuario";
import DialogMensagem from "./components/DialogMensagem.vue";

// Carregamento do emoji-picker
let emojiPickerLoaded = false;

async function loadEmojiPicker() {
  if (!emojiPickerLoaded) {
    await import("emoji-picker-element");
    emojiPickerLoaded = true;
  }
}

const EMPRESAS = {
  "MEMORIAL PARQUE MACEIÓ": {
    channelId: "a3fd21f0-03fe-4d3d-a4f0-2d817e0f2237",
    telefone: "(82) 9122-9510",
  },
  "PARQUE DAS FLORES": {
    channelId: "7b7f46c1-107d-4301-a057-4ddb89a469cc",
    telefone: "(82) 3338-9844",
  },
  PREVIDA: {
    channelId: "b1567a37-5b6d-4aa9-b6d4-bb078323698c",
    telefone: "0800 009 1700",
  },
};

export default {
  name: "ChatWazzup",

  components: {
    FiltroEmpresa,
    DialogMensagem,
  },
  data: () => ({
    // Snackbar
    snackbar: {
      show: false,
      text: "",
      color: "info",
      timeout: 3000,
    },

    meusAtendimentos: false,
    protocolStatusFilter: "aberto",
    // Empresa
    selectedEmpresa: null,
    showFiltroEmpresa: true,
    channelId: null,
    showErrorEmpresa: false,

    // Dialog
    showNewAttendanceDialog: false,
    valid: true,

    // Templates
    templates: [],
    selectedTemplateId: null,
    selectedTemplate: null,
    loadingTemplates: false,

    // Telefone
    phoneNumber: "",

    // Parâmetros do template
    templateParams: [],
    templateParamLabels: {},

    // Estados
    sendingMessage: false,
    checkingContact: false,

    //Protocolos (lista lateral)
    protocolos: [],
    loadingProtocols: false,
    protocolSearch: "",
    statusFilterOptions: [
      {
        value: "aberto",
        label: "Aberto",
        icon: "mdi-lock-open",
        color: "success",
      },
      {
        value: "fechado",
        label: "Fechado",
        icon: "mdi-lock",
        color: "grey",
      },
    ],

    protocoloSelecionado: null,
    selectedProtocolData: null,

    // Detalhes do cliente (sidebar direita)
    showingClientDetails: false, // controla exibição do card de detalhes
    clients: [], // lista completa de clientes retornados pela API
    selectedClientIndex: 0, // índice do cliente selecionado
    clientInfo: null, // informações do cliente selecionado
    loadingClientInfo: false, // loading das infos do cliente
    clientInfoError: null, // erro ao buscar informações do cliente
    panel: 0, // painel de contratos/protocolos
    activeTab: 0, // abas (Parcelas / Interações)

    // Forma de pagamento
    loadingFormaPagamento: null, // ID do documento sendo processado

    // Mensagens (chat)
    messages: [],
    loadingMessages: false,

    freeTextMessage: "",

    showingHistoricalMessages: false,

    // Diálogos de transferência e participante
    showTransferDialog: false,
    showParticipantDialog: false,
    searchColaborador: "",
    colaboradores: [],
    selectedColaboradores: [],
    loadingColaboradores: false,
    transferringAttendance: false,
    addingParticipant: false,
    colaboradoresHeaders: [
      { text: "Nome", value: "nome", align: "start" },
      { text: "E-mail", value: "email" },
      { text: "Departamento", value: "departamento" },
    ],

    // Transferência de fila
    showTransferFilaDialog: false,
    filaDestinoSelecionada: null,
    transferindoFila: false,

    // Diálogo de mensagens do protocolo (visualização detalhada)
    showProtocolMessagesDialog: false,
    protocolMessagesLoading: false,
    protocolMessagesData: null,
    selectedProtocolMessages: [],

    // Editar contato / Adicionar interação
    showEditClientContactDialog: false,
    showAddClientInteractionDialog: false,
    updatingClientContact: false,
    savingClientInteraction: false,
    editClientContactForm: {
      idCliente: null,
      celular: "",
      telefone: "",
      email: "",
      endereco: "",
    },
    addClientInteractionForm: {
      tipo: null,
      contratoId: null,
      descricao: "",
    },
    clienteIvertxAtual: null,
    showClientUpdateResultDialog: false,
    clientUpdateResultMessage: "",
    showClientInteractionResultDialog: false,
    clientInteractionResultMessage: "",

    // Forma de pagamento
    showSelecaoFormaPagamentoDialog: false,
    showFormaPagamentoDialog: false,
    idDocumentoSelecionado: null,
    formaPagamentoResponse: null,
    formaPagamentoLink: null,
    showBoletoPdfDialog: false,
    boletoPdfUrl: null,
    sendingBoleto: false,

    // Filas
    filas: [],
    selectedFilaId: null,
    filaMenu: false,

    // Emoji picker
    showEmojiPicker: false,

    // Anexo de arquivo
    showFileAttachmentDialog: false,
    showFileUrlDialog: false,
    fileUrl: "",
    selectedFile: null,
    selectedFileName: "",
    selectedFileSize: 0,
    sendingFile: false,
    fileError: null,

    // Gravação de áudio
    dialogAudio: false,
    audioRecorder: null,
    isRecording: false,
    audioBlob: null,
    audioURL: null,
    audioDuration: 0,
    audioTimer: null,
    enviandoAudio: false,
    permissaoMicrofone: null,
    solicitandoPermissao: false,
    audioMimeType: "audio/webm",

    // Notificações
    notificacoesHabilitadas: false,

    // Diálogos de confirmação
    showFinalizeProtocolConfirmDialog: false,
    showRemoveParticipantConfirmDialog: false,
    showExitAttendanceConfirmDialog: false,
  }),
  beforeUnmount() {
    WazzupService.disconnect();
  },
  computed: {
    empresaSelecionada() {
      return !this.showFiltroEmpresa && this.selectedEmpresa;
    },
    telefoneEmpresa() {
      if (!this.selectedEmpresa) return null;
      const config = EMPRESAS[this.selectedEmpresa];
      return config?.telefone || null;
    },
    filaSelecionada() {
      if (!this.selectedFilaId || !this.filas || !this.filas.length)
        return null;
      return this.filas.find((fila) => fila.id === this.selectedFilaId) || null;
    },
    // Retorna a fila atual do protocolo selecionado
    filaAtualProtocolo() {
      if (!this.protocoloSelecionado) {
        return null;
      }
      const filaId = this.selectedFilaId;
      if (!filaId) {
        return null;
      }
      const fila = this.filas.find((f) => f.id === filaId);
      return fila ? fila.nomeFila : null;
    },
    // Retorna as filas disponíveis (diferentes da fila atual do protocolo)
    filasDisponiveis() {
      if (!this.filas || !this.filas.length) {
        return [];
      }
      if (!this.selectedFilaId) {
        return this.filas;
      }
      return this.filas.filter((fila) => fila.id !== this.selectedFilaId);
    },
    // Número de clientes retornados pela API (sidebar)
    clientsCount() {
      return this.clients ? this.clients.length : 0;
    },
    loggedIdUser() {
      try {
        const user = JSON.parse(sessionStorage.getItem("user"));
        return user ? user.id : null;
      } catch (error) {
        console.error("Erro ao obter nome do usuário:", error);
        return null;
      }
    },
    isCurrentUserAttendant() {
      if (!this.selectedProtocolData || !this.loggedIdUser) {
        return false;
      }
      return this.selectedProtocolData.atendente === this.loggedIdUser;
    },
    isCurrentUserParticipant() {
      if (!this.selectedProtocolData || !this.loggedIdUser) {
        return false;
      }

      return this.selectedProtocolData.participante === this.loggedIdUser;
    },
    temParticipanteNoProtocolo() {
      if (!this.selectedProtocolData) return false;
      const p = this.selectedProtocolData;
      if (p.participante != null) return true;
      return (p.participantes && p.participantes.length > 0) || false;
    },
    allParametersFilled() {
      if (!this.selectedTemplate) return false;
      return this.templateParams.every((p) => p && p.trim());
    },
    interactionTypes() {
      return [
        { value: 1, label: "Atendimento" },
        { value: 2, label: "Venda" },
        { value: 3, label: "Informação" },
        { value: 5, label: "Cobrança" },
      ];
    },
    availableClientContracts() {
      if (!this.clientInfo || !this.clientInfo.contratos) return [];
      return this.clientInfo.contratos.map((c) => ({
        id: c.id,
        label: c.referencia
          ? `${c.tipo || "Contrato"} - ${c.referencia}`
          : c.tipo || "Contrato",
      }));
    },
    filteredProtocols() {
      let lista = [...this.protocolos];

      if (this.loggedIdUser) {
        lista = lista.filter((p) => {
          return (
            !p.atendente ||
            p.atendente === this.loggedIdUser ||
            p.participante === this.loggedIdUser
          );
        });
      }

      if (this.meusAtendimentos && this.loggedIdUser) {
        lista = lista.filter((p) => {
          const ehResponsavel = p.atendente === this.loggedIdUser;
          const participante = p.participante || null;

          return ehResponsavel || participante === this.loggedIdUser;
        });
      }

      lista = lista.filter((p) => {
        if (!this.protocolSearch) return true;
        const search = this.protocolSearch?.toString().toLowerCase().trim();

        return (
          p.chatId?.toLowerCase().includes(search) ||
          p.numeroProtocolo?.toLowerCase().includes(search) ||
          String(p.id).includes(search)
        );
      });

      return lista.sort((a, b) => {
        const dataA = a.ultimoEventoEm
          ? new Date(a.ultimoEventoEm).getTime()
          : 0;
        const dataB = b.ultimoEventoEm
          ? new Date(b.ultimoEventoEm).getTime()
          : 0;

        return dataB - dataA; // mais recente primeiro
      });
    },
  },

  watch: {
    templateSelecionado(template) {
      this.templateVars = {};

      if (!template || !template.vars) return;

      template.vars.forEach((v) => {
        this.templateVars[v] = "";
      });
    },
    protocolStatusFilter() {
      this.consultarProtocolos();
    },
    selectedEmpresa(nova) {
      if (nova) {
        this.iniciarWebSocket();
        this.fetchFilaTemplatesEmpresa(this.selectedEmpresa);
      }
    },
  },
  mounted() {
    this.iniciarWebSocket();
    this.carregarPreferenciaNotificacao();
  },
  methods: {
    // Alterna exibição da sidebar de detalhes do cliente
    toggleClientDetails() {
      // Se já está mostrando, apenas esconde
      if (this.showingClientDetails) {
        this.showingClientDetails = false;
        return;
      }

      // Se não está mostrando, mostra e busca informações do cliente
      this.showingClientDetails = true;
      this.fetchClientInfo();
    },

    // Buscar informações do cliente a partir do telefone do protocolo selecionado
    async fetchClientInfo() {
      if (!this.selectedProtocolData || !this.selectedProtocolData.chatId) {
        this.clientInfoError = "Número de telefone não encontrado";
        return;
      }

      // Formatar telefone (remover prefixo +55 se existir)
      const telefone = this.selectedProtocolData.chatId.replace(/^\+?55/, "");

      this.loadingClientInfo = true;
      this.clientInfoError = null;

      try {
        const response = await Sonax.getClienteInfo(telefone, "telefone");
        const responseProtocolos = await WazzupService.getProtocolsByPhone(
          telefone,
          this.channelId,
        );

        if (response.data && response.data.length > 0) {
          // Armazena a lista completa de clientes
          this.clients = response.data;

          // Define o primeiro cliente como selecionado por padrão
          this.selectedClientIndex = 0;

          // Define as informações do cliente selecionado
          this.updateSelectedClientInfo(responseProtocolos.data);
          this.loadingClientInfo = false;
        } else {
          this.clients = [];
          this.clientInfo = null;
          this.clientInfoError =
            "Nenhuma informação disponível para este cliente";
        }
      } catch (error) {
        console.error("Erro ao buscar informações do cliente:", error);
        this.clients = [];
        this.clientInfo = null;
        this.clientInfoError =
          error.response?.data || "Erro ao buscar informações do cliente";
      } finally {
        this.loadingClientInfo = false;
      }
    },

    // Atualiza informações do cliente selecionado na sidebar
    updateSelectedClientInfo(protocolos = []) {
      if (
        this.clients.length > 0 &&
        this.selectedClientIndex >= 0 &&
        this.selectedClientIndex < this.clients.length
      ) {
        this.clientInfo = this.clients[this.selectedClientIndex];
        this.clientInfo.protocolos = protocolos;
      } else {
        this.clientInfo = null;
      }
    },

    showSnackbar(text, color = "info", timeout = 3000) {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.timeout = timeout;
      this.snackbar.show = true;
    },

    // Muda o índice do cliente selecionado no select da sidebar
    changeSelectedClient(index) {
      if (index >= 0 && index < this.clients.length) {
        this.selectedClientIndex = index;
        this.updateSelectedClientInfo(this.clientInfo?.protocolos || []);
      }
    },

    // Formatar CPF (XXX.XXX.XXX-XX), igual ao Chat.vue
    formatCpf(cpf) {
      if (!cpf) return "Não informado";

      const cpfClean = cpf.toString().replace(/\D/g, "");
      if (cpfClean.length !== 11) return cpf;

      const initialDigits = cpfClean.slice(0, 3);
      const lastDigits = cpfClean.slice(-2);

      return `${initialDigits}.***.***-${lastDigits}`;
    },

    // Converter data AAAA-MM-DD para DD/MM/AAAA, com tratamento de 1900-01-01
    formatDate(date) {
      if (!date || date === "1900-01-01") return "Não informado";

      // Verificar se a data já está no formato brasileiro
      if (typeof date === "string" && date.includes("/")) return date;

      const [year, month, day] = date.toString().split("-");
      if (!year || !month || !day) return date;
      return `${day}/${month}/${year}`;
    },

    // Formato brasileiro simples (DD/MM/AAAA)
    formatDateBR(date) {
      if (!date) return "Não informado";

      const [year, month, day] = date.toString().split("-");
      if (!year || !month || !day) return date;
      return `${day}/${month}/${year}`;
    },

    // Cor do chip de vencimento (Parcelas)
    getVencimentoColor(dataVencimento, status) {
      if (!dataVencimento) return "grey";

      // Se já foi pago ou quitado
      if (
        status &&
        typeof status === "string" &&
        (status.toLowerCase().includes("pago") ||
          status.toLowerCase().includes("quitado"))
      ) {
        return "success";
      }

      // Verificar se está vencido
      const hoje = new Date();
      const vencimento = new Date(dataVencimento);

      if (vencimento < hoje) {
        return "error";
      }
      return "success";
    },

    // Texto do status de vencimento
    getVencimentoStatus(dataVencimento) {
      if (!dataVencimento) return "Sem data";

      const hoje = new Date();
      const vencimento = new Date(dataVencimento);

      if (vencimento < hoje) {
        return "Vencido";
      }
      return "A vencer";
    },

    // Abrir seleção de forma de pagamento (stub simples baseado no Chat.vue)
    abrirDialogSelecaoFormaPagamento(idDocumento) {
      if (!idDocumento) {
        this.showSnackbar(
          "ID do documento não encontrado para pagamento",
          "error",
        );
        return;
      }

      // Aqui poderíamos abrir um diálogo de seleção de forma de pagamento,
      // como no Chat.vue. Por enquanto apenas marcamos qual documento está
      // sendo processado e informamos o usuário.
      this.loadingFormaPagamento = idDocumento;
      this.showSnackbar(
        "Fluxo de pagamento ainda não implementado neste chat.",
        "warning",
      );
      this.loadingFormaPagamento = null;
    },

    async openEditClientContactDialogFromSidebar() {
      if (!this.clientInfo) {
        this.showSnackbar(
          "Selecione um cliente antes de editar o contato.",
          "error",
        );
        return;
      }
      let cpf =
        this.clientInfo.cpf ||
        this.clientInfo.Inscricao_Ativa ||
        this.clientInfo.cpfCliente ||
        "";

      // Remove qualquer máscara
      cpf = (cpf || "").toString().replace(/\D/g, "");

      if (!cpf) {
        this.showSnackbar(
          "CPF do cliente não encontrado para consulta na iVertex.",
          "error",
        );
        return;
      }

      const response = await Sonax.obterClientePorCpf(cpf);
      const cliente = response?.data;
      this.clienteIvertxAtual = cliente;
      this.prepareEditClientContactForm(cliente);
      this.showEditClientContactDialog = true;
    },
    openAddClientInteractionDialog() {
      if (!this.clientInfo || !this.clientInfo.idCliente) {
        this.showSnackbar(
          "Selecione um cliente antes de adicionar uma interação.",
          "error",
        );
        return;
      }
      this.addClientInteractionForm = {
        tipo: null,
        contratoId: null,
        descricao: "",
      };
      this.showAddClientInteractionDialog = true;
    },

    prepareEditClientContactForm(cliente) {
      if (!cliente) return;
      const logradouro =
        cliente.enderecoLogradouro ||
        cliente.logradouro ||
        cliente.EnderecoLogradouro ||
        "";
      const numero =
        cliente.enderecoNumero ||
        cliente.numero ||
        cliente.EnderecoNumero ||
        "";
      const complemento =
        cliente.enderecoComplemento ||
        cliente.complemento ||
        cliente.EnderecoComplemento ||
        "";
      const bairro =
        cliente.enderecoBairro ||
        cliente.bairro ||
        cliente.EnderecoBairro ||
        "";
      const cidade =
        cliente.enderecoCidade ||
        cliente.cidade ||
        cliente.EnderecoCidade ||
        "";
      const uf = cliente.enderecoUF || cliente.uf || cliente.EnderecoUF || "";
      const cep =
        cliente.enderecoCep || cliente.cep || cliente.EnderecoCep || "";

      const enderecoPartes = [
        [logradouro, numero].filter(Boolean).join(", "),
        complemento,
        [bairro, cidade].filter(Boolean).join(" - "),
        [uf, cep].filter(Boolean).join(" • "),
      ].filter((p) => p && p.trim().length > 0);

      this.editClientContactForm = {
        idCliente: cliente.idCliente || cliente.id || cliente.Id || null,
        celular: cliente.celular || cliente.Celular || cliente.telefone || "",
        telefone: cliente.telefone || cliente.Telefone || "",
        email: cliente.email || cliente.Email || "",
        endereco: enderecoPartes.join("\n"),
      };
    },

    async atualizarContatoCliente() {
      if (!this.editClientContactForm.idCliente) {
        this.showSnackbar("Identificador do cliente não encontrado.", "error");
        return;
      }

      this.updatingClientContact = true;
      const base =
        this.clienteIvertxAtual && Object.keys(this.clienteIvertxAtual).length
          ? this.clienteIvertxAtual
          : {};

      const celularLimpo = (this.editClientContactForm.celular || "")
        .toString()
        .replace(/\D/g, "");
      const telefoneLimpo = (this.editClientContactForm.telefone || "")
        .toString()
        .replace(/\D/g, "");

      const payload = {
        ...base,
        Id:
          this.editClientContactForm.idCliente ||
          base.Id ||
          base.id ||
          base.idCliente,
        Celular: celularLimpo,
        Telefone: telefoneLimpo,
        Email: this.editClientContactForm.email,
      };

      try {
        const response = await Sonax.atualizarCliente(payload);
        const message =
          response?.data?.message ||
          "Operação efetuada com sucesso. (Confirmado)";
        this.clientUpdateResultMessage = message;
        this.showClientUpdateResultDialog = true;
        this.showEditClientContactDialog = false;
      } catch (error) {
        console.error("Erro ao atualizar cliente na iVertex:", error);
        this.showSnackbar(
          error.response?.data ||
            "Erro ao atualizar os dados do cliente na API iVertex.",
          "error",
        );
      } finally {
        this.updatingClientContact = false;
      }
    },

    async salvarInteracaoCliente() {
      if (!this.addClientInteractionForm.tipo) {
        this.showSnackbar("Selecione o tipo de interação.", "error");
        return;
      }
      if (!this.addClientInteractionForm.contratoId) {
        this.showSnackbar("Selecione um contrato.", "error");
        return;
      }
      if (!this.addClientInteractionForm.descricao) {
        this.showSnackbar("Informe a descrição da interação.", "error");
        return;
      }

      this.savingClientInteraction = true;
      const idEntidade =
        this.clientInfo.idCliente || this.clientInfo.Id || null;
      const nomeContato =
        this.clientInfo.nome || this.clientInfo.NomeCompleto || "Não informado";

      let assunto = "Interação de cliente";
      if (this.clientInfo.contratos && this.clientInfo.contratos.length > 0) {
        const contratoSelecionado = this.clientInfo.contratos.find(
          (c) => c.id === this.addClientInteractionForm.contratoId,
        );
        if (contratoSelecionado) {
          assunto =
            contratoSelecionado.referencia ||
            contratoSelecionado.tipo ||
            assunto;
        }
      }

      try {
        const response = await Sonax.salvarInteracaoCliente({
          idEntidade,
          tipo: this.addClientInteractionForm.tipo,
          nomeContato,
          assunto,
          descricaoInteracao: this.addClientInteractionForm.descricao,
        });

        const message =
          response?.data?.message || "Interação do cliente salva com sucesso.";
        this.clientInteractionResultMessage = message;
        this.showClientInteractionResultDialog = true;
        this.showAddClientInteractionDialog = false;
      } catch (error) {
        console.error("Erro ao salvar interação do cliente:", error);
        this.showSnackbar(
          error.response?.data?.message || "Erro ao salvar interação",
          "error",
        );
      } finally {
        this.savingClientInteraction = false;
      }
    },

    abrirDialogSelecaoFormaPagamento(idDocumento) {
      this.idDocumentoSelecionado = idDocumento;
      this.showSelecaoFormaPagamentoDialog = true;
    },

    closeSelecaoFormaPagamentoDialog() {
      if (this.loadingFormaPagamento !== null) return;
      this.showSelecaoFormaPagamentoDialog = false;
      this.idDocumentoSelecionado = null;
    },

    async selecionarFormaPagamento(formaPagamento) {
      if (this.loadingFormaPagamento !== null) return;

      const idDocumento = this.idDocumentoSelecionado;
      const protocolo = this.protocoloSelecionado?.numeroProtocolo || null;

      let formaPagamentoParaEnviar = formaPagamento;
      if (formaPagamento === "PDF Boleto") formaPagamentoParaEnviar = "PDF";
      else if (formaPagamento === "Link de Pagamento")
        formaPagamentoParaEnviar = "Link";
      else if (formaPagamento === "Código de Barras")
        formaPagamentoParaEnviar = "Barras";

      if (idDocumento) {
        await this.gerarFormaPagamento(
          idDocumento,
          formaPagamentoParaEnviar,
          protocolo,
        );
        this.closeSelecaoFormaPagamentoDialog();
      } else {
        this.showSnackbar("ID do documento não encontrado", "error");
      }
    },

    async gerarFormaPagamento(idDocumento, formaPagamento, protocolo) {
      if (!idDocumento) {
        this.showSnackbar("ID do documento não encontrado", "error");
        return;
      }
      if (!formaPagamento) {
        this.showSnackbar("Forma de pagamento não selecionada", "error");
        return;
      }

      this.loadingFormaPagamento = idDocumento;

      try {
        let telefone = null;
        if (this.protocoloSelecionado?.chatId) {
          telefone = this.protocoloSelecionado.chatId.replace(/^\+?55/, "");
        }

        const response = await Sonax.gerarFormaPagamento(
          idDocumento,
          telefone,
          null,
          formaPagamento,
          protocolo,
        );

        if (response.data) {
          if (response.data.message) {
            this.formaPagamentoResponse = response.data.message;
            this.formaPagamentoLink = null;
            this.showFormaPagamentoDialog = true;
            if (this.protocoloSelecionado) await this.consultarMensagens();
          } else if (
            response.data.formaPagamento !== undefined &&
            response.data.formaPagamento === ""
          ) {
            this.formaPagamentoResponse =
              "Esta forma de pagamento não está habilitada para este documento.";
            this.formaPagamentoLink = null;
            this.showFormaPagamentoDialog = true;
          } else if (response.data.formaPagamento) {
            // Verificar se é um boleto PDF
            const isBoleto =
              response.data.formaPagamento.toLowerCase().includes("boleto") &&
              response.data.formaPagamento.toLowerCase().endsWith(".pdf");

            if (isBoleto) {
              // Abrir diálogo específico para boleto PDF
              this.boletoPdfUrl = response.data.formaPagamento;
              this.showBoletoPdfDialog = true;
            } else {
              // Outros tipos de forma de pagamento (Pix, Link, etc.)
              this.formaPagamentoResponse = null;
              this.formaPagamentoLink = response.data.formaPagamento;
              this.showFormaPagamentoDialog = true;
            }

            if (this.protocoloSelecionado) await this.consultarMensagens();
          } else {
            this.showSnackbar("Resposta inválida da API", "error");
          }
        } else {
          this.showSnackbar("Erro ao gerar forma de pagamento", "error");
        }
      } catch (error) {
        console.error("Erro ao gerar forma de pagamento:", error);
        this.showSnackbar(
          error.response?.data?.message || "Erro ao gerar forma de pagamento",
          "error",
        );
      } finally {
        this.loadingFormaPagamento = null;
      }
    },

    closeFormaPagamentoDialog() {
      this.showFormaPagamentoDialog = false;
      this.formaPagamentoResponse = null;
      this.formaPagamentoLink = null;
    },

    closeBoletoPdfDialog() {
      this.showBoletoPdfDialog = false;
      this.boletoPdfUrl = null;
    },

    async enviarBoletoParaCliente() {
      if (!this.boletoPdfUrl || !this.protocoloSelecionado) {
        this.showSnackbar(
          "Erro: URL do boleto ou protocolo não encontrado",
          "error",
        );
        return;
      }

      this.sendingBoleto = true;

      try {
        const response = await WazzupService.enviarArquivo({
          channelId: this.channelId,
          telefone: this.protocoloSelecionado.chatId,
          protocolo: this.protocoloSelecionado.numeroProtocolo,
          fileUrl: this.boletoPdfUrl,
        });

        if (
          response.status >= 200 &&
          response.status < 300 &&
          (!response.data || !response.data.error)
        ) {
          this.showSnackbar("Boleto enviado com sucesso!", "success");
          this.closeBoletoPdfDialog();
          await this.consultarMensagens();
        } else {
          this.showSnackbar(
            response.data?.message || "Erro ao enviar boleto",
            "error",
          );
        }
      } catch (error) {
        console.error("Erro ao enviar boleto:", error);
        this.showSnackbar(
          error.response?.data?.message ||
            error.message ||
            "Erro ao enviar boleto",
          "error",
        );
      } finally {
        this.sendingBoleto = false;
      }
    },

    async copiarLinkFormaPagamento() {
      if (!this.formaPagamentoLink) return;
      try {
        await navigator.clipboard.writeText(this.formaPagamentoLink);
        this.showSnackbar(
          "Link copiado para a área de transferência",
          "success",
        );
      } catch (error) {
        const textArea = document.createElement("textarea");
        textArea.value = this.formaPagamentoLink;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          this.showSnackbar(
            "Link copiado para a área de transferência",
            "success",
          );
        } catch (err) {
          this.showSnackbar("Erro ao copiar link", "error");
        }
        document.body.removeChild(textArea);
      }
    },

    async copiarTextoFormaPagamento() {
      if (!this.formaPagamentoResponse) return;
      try {
        await navigator.clipboard.writeText(this.formaPagamentoResponse);
        this.showSnackbar(
          "Texto copiado para a área de transferência",
          "success",
        );
      } catch (error) {
        const textArea = document.createElement("textarea");
        textArea.value = this.formaPagamentoResponse;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand("copy");
          this.showSnackbar(
            "Texto copiado para a área de transferência",
            "success",
          );
        } catch (err) {
          this.showSnackbar("Erro ao copiar texto", "error");
        }
        document.body.removeChild(textArea);
      }
    },

    async enviarMensagemFormaPagamento() {
      if (!this.formaPagamentoLink || !this.protocoloSelecionado) {
        this.showSnackbar("Link ou protocolo não encontrado", "error");
        return;
      }

      this.sendingMessage = true;
      try {
        await WazzupService.enviarMensagem({
          protocolo: this.protocoloSelecionado.numeroProtocolo,
          mensagem: this.formaPagamentoLink,
          channelId: this.channelId,
          telefone: this.protocoloSelecionado.chatId,
        });

        this.showSnackbar("Mensagem enviada com sucesso", "success");
        await this.consultarMensagens();
        this.closeFormaPagamentoDialog();
      } catch (error) {
        console.error("Erro ao enviar mensagem:", error);
        this.showSnackbar(
          error.response?.data?.message || "Erro ao enviar mensagem",
          "error",
        );
      } finally {
        this.sendingMessage = false;
      }
    },

    async enviarMensagemTextoFormaPagamento() {
      if (!this.formaPagamentoResponse || !this.protocoloSelecionado) {
        this.showSnackbar("Mensagem ou protocolo não encontrado", "error");
        return;
      }

      this.sendingMessage = true;
      try {
        await WazzupService.enviarMensagem({
          protocolo: this.protocoloSelecionado.numeroProtocolo,
          mensagem: this.formaPagamentoResponse,
          channelId: this.channelId,
          telefone: this.protocoloSelecionado.chatId,
        });

        this.showSnackbar("Mensagem enviada com sucesso", "success");
        await this.consultarMensagens();
        this.closeFormaPagamentoDialog();
      } catch (error) {
        console.error("Erro ao enviar mensagem:", error);
        this.showSnackbar(
          error.response?.data?.message || "Erro ao enviar mensagem",
          "error",
        );
      } finally {
        this.sendingMessage = false;
      }
    },

    async abrirProtocolo(protocolo) {
      const idProtocolo = protocolo?.id ?? protocolo?.idProtocolo;
      if (!protocolo || !idProtocolo) {
        this.showSnackbar("Protocolo inválido", "error");
        return;
      }

      this.protocolMessagesLoading = true;
      this.protocolMessagesData = protocolo;
      this.showProtocolMessagesDialog = true;
      this.selectedProtocolMessages = [];

      try {
        const { data } = await WazzupService.listarMensagens(idProtocolo);
        this.selectedProtocolMessages = Array.isArray(data) ? data : [];
      } catch (error) {
        console.error("Erro ao buscar mensagens do protocolo:", error);
        this.showSnackbar(
          error.response?.data?.message ||
            "Erro ao buscar mensagens do protocolo",
          "error",
        );
      } finally {
        this.protocolMessagesLoading = false;
      }
    },

    closeProtocolMessagesDialog() {
      this.showProtocolMessagesDialog = false;
      this.protocolMessagesData = null;
      this.selectedProtocolMessages = [];
    },
    notificarMensagemNova() {
      if (!this.notificacoesHabilitadas) {
        return;
      }

      // Reproduzir som de alerta
      const audio = new Audio(require("@/assets/sounds/alerta.wav"));
      audio.play().catch((error) => {
        console.error("❌ Erro ao reproduzir som de alerta:", error);
      });
    },

    // Verificar se o navegador suporta e tem permissão para notificações
    verificarPermissaoNotificacao() {
      if ("Notification" in window) {
        this.notificacoesPermitidas = Notification.permission === "granted";
      } else {
        this.notificacoesPermitidas = false;
      }
    },

    // Carregar preferência de notificação do localStorage
    carregarPreferenciaNotificacao() {
      const preferencia = localStorage.getItem(
        "chatWazzup_notificacoesHabilitadas",
      );
      if (preferencia !== null) {
        this.notificacoesHabilitadas = preferencia === "true";
      }
    },

    // Toggle de notificações
    async toggleNotificacoes() {
      console.log(
        "🔄 Toggle notificações - Novo estado:",
        this.notificacoesHabilitadas,
      );
      // Salvar preferência no localStorage
      localStorage.setItem(
        "chatWazzup_notificacoesHabilitadas",
        this.notificacoesHabilitadas.toString(),
      );
    },

    // Métodos para anexo de arquivo
    openFileAttachmentDialog() {
      this.showFileAttachmentDialog = true;
      this.selectedFile = null;
      this.selectedFileName = "";
      this.selectedFileSize = 0;
      this.fileError = null;
    },

    closeFileAttachmentDialog() {
      this.showFileAttachmentDialog = false;
      this.selectedFile = null;
      this.selectedFileName = "";
      this.selectedFileSize = 0;
      this.fileError = null;
    },

    closeFileUrlDialog() {
      this.showFileUrlDialog = false;
      this.fileUrl = "";
    },

    onFileSelected(file) {
      if (file) {
        this.selectedFileName = file.name;
        this.selectedFileSize = file.size;
        this.fileError = null;
      }
    },

    formatFileSize(bytes) {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },

    async sendAttachedFile() {
      if (!this.selectedFile || !this.protocoloSelecionado) {
        this.fileError =
          "Selecione um arquivo e certifique-se de que há um protocolo ativo";
        return;
      }

      this.sendingFile = true;
      this.fileError = null;

      try {
        const response = await WazzupService.enviarArquivo({
          channelId: this.channelId,
          telefone: this.protocoloSelecionado.chatId,
          protocolo: this.protocoloSelecionado.numeroProtocolo,
          file: this.selectedFile,
        });

        // Sucesso se status 200-299 ou se data não tem erro
        if (
          response.status >= 200 &&
          response.status < 300 &&
          (!response.data || !response.data.error)
        ) {
          this.closeFileAttachmentDialog();
          this.showFileUrlDialog = true;
          setTimeout(() => {
            this.closeFileUrlDialog();
          }, 5000);
          console.log("✅ Arquivo enviado com sucesso");
          await this.consultarMensagens();
        } else {
          this.fileError = response.data?.message || "Erro ao enviar arquivo";
        }
      } catch (error) {
        console.error("Erro ao enviar arquivo:", error);
        this.fileError =
          error.response?.data?.message ||
          error.message ||
          "Erro ao enviar arquivo";
      } finally {
        this.sendingFile = false;
      }
    },

    // Métodos de gravação de áudio
    openAudioDialog() {
      this.dialogAudio = true;
      this.resetarEstadoAudio();
    },

    fecharDialogAudio() {
      if (this.isRecording) {
        this.pararGravacao();
      }
      this.resetarEstadoAudio();
      this.dialogAudio = false;
    },

    resetarEstadoAudio() {
      if (this.audioURL) {
        URL.revokeObjectURL(this.audioURL);
      }
      if (this.audioTimer) {
        clearInterval(this.audioTimer);
      }
      this.audioRecorder = null;
      this.isRecording = false;
      this.audioBlob = null;
      this.audioURL = null;
      this.audioDuration = 0;
      this.audioTimer = null;
    },

    solicitarPermissaoMicrofone() {
      this.solicitandoPermissao = true;
      navigator.mediaDevices
        .getUserMedia({ audio: true })
        .then((stream) => {
          this.permissaoMicrofone = true;
          this.prepararGravador(stream);
        })
        .catch((error) => {
          console.error("Erro ao solicitar permissão de microfone:", error);
          this.permissaoMicrofone = false;
        })
        .finally(() => {
          this.solicitandoPermissao = false;
        });
    },

    prepararGravador(stream) {
      try {
        // Priorizar OGG primeiro
        const mimeTypes = [
          "audio/ogg;codecs=opus",
          "audio/ogg",
          "audio/webm;codecs=opus",
          "audio/webm",
          "audio/mp4",
          "audio/mp4;codecs=mp4a.40.2",
          "audio/mpeg",
          "audio/mp3",
        ];

        let selectedMimeType = "audio/webm"; // fallback

        console.log("🔍 Testando suporte de mimeTypes:");
        for (const mimeType of mimeTypes) {
          const isSupported = MediaRecorder.isTypeSupported(mimeType);
          console.log(
            `  ${mimeType}: ${
              isSupported ? "✅ Suportado" : "❌ Não suportado"
            }`,
          );
          if (isSupported && selectedMimeType === "audio/webm") {
            selectedMimeType = mimeType;
          }
        }

        console.log("🎤 MimeType selecionado para gravação:", selectedMimeType);

        this.audioMimeType = selectedMimeType;
        const options = { mimeType: selectedMimeType };
        this.audioRecorder = new MediaRecorder(stream, options);
        this.audioRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            const chunks = [];
            chunks.push(event.data);
            this.audioBlob = new Blob(chunks, { type: selectedMimeType });
            this.audioURL = URL.createObjectURL(this.audioBlob);
          }
        };
        this.audioRecorder.onstop = () => {
          stream.getTracks().forEach((track) => track.stop());
        };
      } catch (error) {
        console.error("Erro ao preparar gravador:", error);
      }
    },

    iniciarGravacao() {
      if (!this.audioRecorder) return;
      try {
        this.audioRecorder.start();
        this.isRecording = true;
        this.audioDuration = 0;
        this.audioTimer = setInterval(() => {
          this.audioDuration++;
          if (this.audioDuration >= 120) {
            this.pararGravacao();
          }
        }, 1000);
      } catch (error) {
        console.error("Erro ao iniciar gravação:", error);
      }
    },

    pararGravacao() {
      if (!this.audioRecorder || this.audioRecorder.state === "inactive")
        return;
      try {
        this.audioRecorder.stop();
        this.isRecording = false;
        if (this.audioTimer) {
          clearInterval(this.audioTimer);
        }
      } catch (error) {
        console.error("Erro ao parar gravação:", error);
      }
    },

    descartarAudio() {
      this.resetarEstadoAudio();
      this.solicitarPermissaoMicrofone();
    },

    formatAudioTime(seconds) {
      const mins = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${mins.toString().padStart(2, "0")}:${secs
        .toString()
        .padStart(2, "0")}`;
    },

    async enviarAudio() {
      if (!this.audioBlob || !this.protocoloSelecionado) return;
      this.enviandoAudio = true;

      // Enviar sempre em WEBM
      const fileName = `Audio_${this.formatAudioTime(this.audioDuration)}.webm`;

      console.log("📤 Enviando áudio WEBM:");
      console.log("  - Nome do arquivo:", fileName);
      console.log("  - Tamanho:", this.audioBlob.size, "bytes");

      const audioFile = new File([this.audioBlob], fileName, {
        type: "audio/webm",
      });
      try {
        const response = await WazzupService.enviarArquivo({
          channelId: this.channelId,
          telefone: this.protocoloSelecionado.chatId,
          protocolo: this.protocoloSelecionado.numeroProtocolo,
          file: audioFile,
          isAudio: true,
        });
        // Sucesso se status 200-299 ou se data não tem erro
        if (
          response.status >= 200 &&
          response.status < 300 &&
          (!response.data || !response.data.error)
        ) {
          this.fecharDialogAudio();
          this.showFileUrlDialog = true;
          setTimeout(() => {
            this.closeFileUrlDialog();
          }, 5000);
          console.log("✅ Áudio WEBM enviado com sucesso");
          await this.consultarMensagens();
        } else {
          console.error("Erro ao enviar áudio:", response.data);
        }
      } catch (error) {
        console.error("Erro ao enviar áudio:", error);
      } finally {
        this.enviandoAudio = false;
      }
    },
    async iniciarWebSocket() {
      if (this.selectedEmpresa === null) {
        return;
      }

      WazzupService.connectWebSocket({
        onConnect: () => {
          console.log("🟢 WS conectado");
          WazzupService.subscribeProtocoloAtualizado((protocoloId) => {
            this.onProtocoloAtualizado(protocoloId);
            this.notificarMensagemNova();
          });
        },
        onError: (err) => {
          console.error("🔴 Erro WS:", err);
        },
      });
    },
    async onProtocoloAtualizado(protocoloId) {
      try {
        const id = Number(protocoloId);

        if (isNaN(id)) {
          console.warn("⚠️ ID inválido! Abortando execução.");
          return;
        }

        const response = await WazzupService.listarProtocoloPorId(id);

        const protocoloAtualizado = response?.data;

        if (!protocoloAtualizado) {
          console.warn("⚠️ API não retornou dados!");
          return;
        }

        // Verificar se o channelId do protocolo corresponde ao channelId selecionado
        if (
          this.channelId &&
          protocoloAtualizado.channelId !== this.channelId
        ) {
          return;
        }

        await this.consultarProtocolos(false);

        if (this.protocoloSelecionado?.id === id) {
          this.protocoloSelecionado = protocoloAtualizado;

          await this.consultarMensagens();
        }
      } catch (e) {
        console.error("❌ Erro ao processar atualização de protocolo:", e);
      }
    },
    async filterDataEmpresa(filterData) {
      const empresaSelecionada = filterData.selectedCompany || null;

      if (!empresaSelecionada) return;

      const channelId = this.verificarChannelIdEmpresa(empresaSelecionada);

      if (!channelId) return;

      this.selectedEmpresa = empresaSelecionada;
      this.showFiltroEmpresa = false;
      await this.fetchFilaTemplatesEmpresa(empresaSelecionada);
      await this.consultarProtocolos();
    },
    verificarChannelIdEmpresa(empresa) {
      const config = EMPRESAS[empresa];

      if (!config) {
        this.showErrorEmpresa = true;
        return null;
      }

      this.channelId = config.channelId;

      return config.channelId;
    },
    async consultarProtocolos(showLoading = true) {
      if (showLoading) {
        this.carregandoProtocolos = true;
        this.protocolos = [];
      }

      try {
        const params = {
          channelId: this.channelId,
          status: this.protocolStatusFilter,
          dtInicio: null,
          dtFim: null,
          filaId: this.selectedFilaId,
        };

        const response = await WazzupService.listarProtocolos(params);

        if (response.data && Array.isArray(response.data)) {
          this.protocolos = response.data;
        } else {
          this.protocolos = [];
        }
      } catch (error) {
        console.error("Erro ao consultar protocolos:", error);
        this.protocolos = [];
      } finally {
        if (showLoading) {
          this.carregandoProtocolos = false;
        }
      }
    },
    async fetchFilaTemplatesEmpresa(empresa) {
      if (!empresa) {
        return;
      }
      try {
        // Carregar filas
        const response = await Sonax.listarFilaTemplatesEmpresa(empresa);
        if (response.data && !response.data.error && response.data) {
          const filas = response.data;
          this.filas = filas;

          // Seleciona a primeira fila por padrão, caso nenhuma esteja selecionada
          if (filas.length) {
            const primeiraFilaId = filas[0].id;
            if (
              !this.selectedFilaId ||
              !filas.some((f) => f.id === this.selectedFilaId)
            ) {
              this.selectedFilaId = primeiraFilaId;
            }
          } else {
            this.selectedFilaId = null;
          }
        }

        // Carregar templates da empresa (filtrar apenas os que não são URA)
        await this.carregarTemplatesEmpresa(empresa);
      } catch (error) {
        console.error("Erro ao carregar filas template:", error);
      }
    },

    async carregarTemplatesEmpresa(empresa) {
      if (!empresa) {
        this.templates = [];
        return;
      }

      try {
        this.loadingTemplates = true;
        const response = await WazzupService.listarTemplates(empresa);

        if (response.data && Array.isArray(response.data)) {
          // Filtrar apenas templates onde ura === false
          const templatesNaoUra = response.data.filter(
            (template) => template.ura === false,
          );

          // Mapear para o formato esperado pelo componente
          this.templates = templatesNaoUra.map((template) => ({
            id: template.id,
            nome: template.nome,
            content: template.texto,
            vars: this.extractTemplateParams(template.texto),
            idExterno: template.idExterno || null,
          }));

          console.log(
            `✅ ${this.templates.length} templates carregados para ${empresa}`,
          );
        } else {
          this.templates = [];
        }
      } catch (error) {
        console.error("Erro ao carregar templates:", error);
        this.templates = [];
        this.showSnackbar("Erro ao carregar templates", "error");
      } finally {
        this.loadingTemplates = false;
      }
    },
    onSelecionarFila(fila) {
      if (!fila) return;
      this.selectedFilaId = fila.id;
      this.filaMenu = false;
      this.consultarProtocolos();
    },
    async selecionarProtocolo(protocolo) {
      this.protocoloSelecionado = protocolo;
      await this.consultarMensagens();
    },

    async consultarMensagens() {
      if (!this.protocoloSelecionado) return;
      this.loadingMessages = true;

      const { data } = await WazzupService.listarMensagens(
        this.protocoloSelecionado.id,
      );

      this.messages = data;
      this.loadingMessages = false;

      this.$nextTick(() => {
        const chatContainer = document.querySelector(".chat-container");
        if (chatContainer) {
          chatContainer.scrollTop = chatContainer.scrollHeight;
        }
      });
    },
    async iniciarAtendimento() {
      if (!this.templateSelecionado) return;

      await WazzupService.iniciarAtendimento({
        channelId: this.channelId,
        templateId: this.templateSelecionado.id,
        vars: this.templateVars,
      });

      await this.consultarProtocolos(false);
    },
    async enviarMensagem() {
      if (!this.freeTextMessage || !this.protocoloSelecionado) return;

      await WazzupService.enviarMensagem({
        protocolo: this.protocoloSelecionado.numeroProtocolo,
        mensagem: this.freeTextMessage,
        channelId: this.channelId,
        telefone: this.protocoloSelecionado.chatId,
      });

      this.freeTextMessage = "";
      await this.consultarMensagens();
    },
    async checkContactAndSend() {
      this.sendingMessage = true;

      try {
        await WazzupService.iniciarAtendimento({
          channelId: this.channelId,
          telefone: this.phoneNumber,
          templateId: this.selectedTemplate.id,
          parametros: this.templateParams,
        });

        this.showNewAttendanceDialog = false;
        await this.consultarProtocolos(false);

        this.$refs.dialogMensagem.show(
          "success",
          "Atendimento iniciado",
          "A conversa foi iniciada com sucesso.",
        );
      } catch (error) {
        console.error("Erro ao iniciar atendimento:", error);

        const mensagemErro =
          error?.response?.data?.message ||
          "Erro inesperado ao iniciar atendimento.";

        this.$refs.dialogMensagem.show(
          "error",
          "Erro ao iniciar atendimento",
          mensagemErro,
        );
      } finally {
        this.sendingMessage = false;
      }
    },
    async selectProtocol(protocolo) {
      this.protocoloSelecionado = protocolo;
      this.selectedProtocolData = protocolo;

      const index = this.protocolos.findIndex((p) => p.id === protocolo.id);

      if (index !== -1) {
        this.$set(this.protocolos[index], "temMensagemNaoLida", false);
      }

      await this.consultarMensagens();
      this.$nextTick(() => {
        const chatContainer = document.querySelector(".chat-container");
        if (chatContainer) {
          chatContainer.scrollTop = chatContainer.scrollHeight;
        }
      });
    },
    async aceitarAtendimento() {
      if (!this.protocoloSelecionado) return;

      try {
        await WazzupService.aceitarAtendimento(this.protocoloSelecionado.id);

        this.showSnackbar("Atendimento aceito com sucesso", "success");

        await this.consultarProtocolos(false);

        const atualizado = this.protocolos.find(
          (p) => p.id === this.protocoloSelecionado.id,
        );
        if (atualizado) {
          this.protocoloSelecionado = atualizado;
          this.selectedProtocolData = atualizado;
        }
      } catch (error) {
        console.error("Erro ao aceitar atendimento:", error);
        this.showSnackbar(
          error.response?.data?.message ||
            "Erro ao aceitar atendimento. Tente novamente.",
          "error",
        );
      }
    },
    abrirDialogTransferencia() {
      if (!this.protocoloSelecionado) return;
      this.showTransferDialog = true;
      this.selectedColaboradores = [];
      this.carregarColaboradores();
    },
    async carregarColaboradores() {
      if (!this.selectedEmpresa) return;
      this.loadingColaboradores = true;
      try {
        const response = await UsuarioService.todos_ativos_com_colaborador(
          this.selectedEmpresa,
        );
        if (response.data && Array.isArray(response.data)) {
          this.colaboradores = response.data
            .filter((c) => c.id !== this.loggedIdUser)
            .map((c) => ({
              id: c.id,
              nome: c.nome,
              email: c.email || "",
              departamento: c.departamento || "Não informado",
            }));
        } else {
          this.colaboradores = [];
        }
      } catch (error) {
        console.error("Erro ao carregar colaboradores:", error);
        this.showSnackbar(
          error.response?.data?.message || "Erro ao carregar colaboradores",
          "error",
        );
        this.colaboradores = [];
      } finally {
        this.loadingColaboradores = false;
      }
    },
    async executarTransferencia() {
      if (!this.protocoloSelecionado || !this.selectedColaboradores?.length) {
        this.showSnackbar(
          "Selecione um colaborador para transferir o atendimento",
          "warning",
        );
        return;
      }
      const colaborador = this.selectedColaboradores[0];
      const protocoloId = this.protocoloSelecionado.id;
      this.transferringAttendance = true;
      try {
        await WazzupService.transferirAtendimento(protocoloId, colaborador.id);
        this.showSnackbar(
          `Atendimento transferido com sucesso para ${colaborador.nome}`,
          "success",
        );
        this.showTransferDialog = false;
        this.selectedColaboradores = [];
        this.searchColaborador = "";
        this.selectedProtocolData = null;
        this.protocoloSelecionado = null;
        await this.consultarProtocolos(false);
        const atualizado = this.protocolos.find((p) => p.id === protocoloId);
        if (atualizado) {
          this.protocoloSelecionado = atualizado;
          this.selectedProtocolData = atualizado;
        }
      } catch (error) {
        console.error("Erro ao transferir atendimento:", error);
        this.showSnackbar(
          error.response?.data?.message ||
            "Erro ao transferir atendimento. Tente novamente.",
          "error",
        );
      } finally {
        this.transferringAttendance = false;
      }
    },
    abrirDialogParticipante() {
      if (!this.protocoloSelecionado) return;
      this.showParticipantDialog = true;
      this.selectedColaboradores = [];
      this.carregarColaboradores();
    },

    // Abrir diálogo de transferência de fila
    abrirDialogTransferenciaFila() {
      if (!this.protocoloSelecionado) {
        this.showSnackbar("Nenhum protocolo selecionado", "warning");
        return;
      }

      if (!this.filas || !this.filas.length) {
        this.showSnackbar(
          "Nenhuma fila disponível para transferência",
          "warning",
        );
        return;
      }

      this.filaDestinoSelecionada = null;
      this.showTransferFilaDialog = true;
    },

    // Fechar diálogo de transferência de fila
    fecharDialogTransferenciaFila() {
      this.showTransferFilaDialog = false;
      this.filaDestinoSelecionada = null;
      this.transferindoFila = false;
    },

    // Executar transferência de fila
    async executarTransferenciaFila() {
      if (!this.filaDestinoSelecionada || !this.protocoloSelecionado) {
        this.showSnackbar("Selecione uma fila de destino", "warning");
        return;
      }

      this.transferindoFila = true;

      try {
        await WazzupService.transferirFila(
          this.protocoloSelecionado.numeroProtocolo,
          this.filaDestinoSelecionada,
        );

        const filaDestino = this.filas.find(
          (f) => f.id === this.filaDestinoSelecionada,
        );

        this.showSnackbar(
          `Protocolo transferido com sucesso para a fila "${
            filaDestino?.nomeFila || "selecionada"
          }"`,
          "success",
        );

        this.fecharDialogTransferenciaFila();

        // Limpar seleção do protocolo
        this.protocoloSelecionado = null;
        this.selectedProtocolData = null;
        this.messages = [];

        // Atualizar lista de protocolos
        await this.consultarProtocolos();
      } catch (error) {
        console.error("Erro ao transferir fila:", error);
        this.showSnackbar(
          error.response?.data?.message || "Erro ao transferir fila",
          "error",
        );
      } finally {
        this.transferindoFila = false;
      }
    },

    // Abrir diálogo de confirmação para sair do atendimento
    sairAtendimento() {
      if (!this.protocoloSelecionado) return;
      this.showExitAttendanceConfirmDialog = true;
    },

    // Cancelar saída do atendimento
    cancelExitAttendance() {
      this.showExitAttendanceConfirmDialog = false;
    },

    // Executar saída do atendimento
    async executeExitAttendance() {
      this.showExitAttendanceConfirmDialog = false;

      if (!this.protocoloSelecionado) return;

      try {
        await WazzupService.sairAtendimento(this.protocoloSelecionado.id);

        this.showSnackbar("Você saiu do atendimento", "success");

        await this.consultarProtocolos(false);

        this.protocoloSelecionado = null;
        this.selectedProtocolData = null;
        this.messages = [];
      } catch (error) {
        console.error("Erro ao sair do atendimento:", error);
        this.showSnackbar(
          error.response?.data?.message ||
            "Erro ao sair do atendimento. Tente novamente.",
          "error",
        );
      }
    },
    // Abrir diálogo de confirmação para finalizar protocolo
    finalizarProtocolo() {
      if (!this.protocoloSelecionado) return;
      this.showFinalizeProtocolConfirmDialog = true;
    },

    // Cancelar finalização de protocolo
    cancelFinalizeProtocol() {
      this.showFinalizeProtocolConfirmDialog = false;
    },

    // Executar finalização de protocolo
    async executeFinalizeProtocol() {
      this.showFinalizeProtocolConfirmDialog = false;

      if (!this.protocoloSelecionado) return;

      try {
        await WazzupService.finalizarProtocolo(this.protocoloSelecionado.id);

        this.showSnackbar("Protocolo finalizado com sucesso", "success");

        await this.consultarProtocolos(false);

        this.protocoloSelecionado = null;
        this.selectedProtocolData = null;
        this.messages = [];
      } catch (error) {
        console.error("Erro ao finalizar protocolo:", error);
        this.showSnackbar(
          error.response?.data?.message ||
            "Erro ao finalizar protocolo. Tente novamente.",
          "error",
        );
      }
    },
    async adicionarParticipante() {
      if (!this.protocoloSelecionado || !this.selectedColaboradores?.length) {
        this.showSnackbar(
          "Selecione um colaborador para adicionar como participante",
          "warning",
        );
        return;
      }
      const colaborador = this.selectedColaboradores[0];
      this.addingParticipant = true;
      try {
        await WazzupService.adicionarParticipante(
          this.protocoloSelecionado.id,
          colaborador.id,
        );
        this.showSnackbar(
          `${colaborador.nome} adicionado como participante com sucesso`,
          "success",
        );
        this.showParticipantDialog = false;
        this.selectedColaboradores = [];
        this.searchColaborador = "";
        await this.consultarProtocolos(false);
        const atualizado = this.protocolos.find(
          (p) => p.id === this.protocoloSelecionado.id,
        );
        if (atualizado) {
          this.protocoloSelecionado = atualizado;
          this.selectedProtocolData = atualizado;
        }
      } catch (error) {
        console.error("Erro ao adicionar participante:", error);
        this.showSnackbar(
          error.response?.data?.message ||
            "Erro ao adicionar participante. Tente novamente.",
          "error",
        );
      } finally {
        this.addingParticipant = false;
      }
    },
    // Abrir diálogo de confirmação para remover participante
    removerParticipante() {
      if (!this.protocoloSelecionado) return;
      this.showRemoveParticipantConfirmDialog = true;
    },

    // Cancelar remoção de participante
    cancelRemoveParticipant() {
      this.showRemoveParticipantConfirmDialog = false;
    },

    // Executar remoção de participante
    async executeRemoveParticipant() {
      this.showRemoveParticipantConfirmDialog = false;

      if (!this.protocoloSelecionado) return;

      try {
        await WazzupService.removerParticipante(this.protocoloSelecionado.id);

        this.showSnackbar("Participante removido com sucesso", "success");

        await this.consultarProtocolos(false);
      } catch (error) {
        console.error("Erro ao remover participante:", error);
        this.showSnackbar(
          error.response?.data?.message ||
            "Erro ao remover participante. Tente novamente.",
          "error",
        );
      }
    },
    // Fechar diálogo de novo atendimento
    closeNewAttendanceDialog() {
      this.showNewAttendanceDialog = false;
      // Limpar formulário
      this.phoneNumber = "";
      this.selectedTemplateId = null;
      this.selectedTemplate = null;
      this.templateParams = [];
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    async onTemplateSelectChange(templateId) {
      this.selectedTemplate =
        this.templates.find((t) => t.id === templateId) || null;

      this.templateParams = [];

      if (this.selectedTemplate?.vars?.length) {
        this.templateParams = this.selectedTemplate.vars.map(() => "");
      }
    },
    extractTemplateParams(texto) {
      if (!texto) return [];

      // Contar quantos {} existem no texto
      const matches = texto.match(/\{\}/g);
      const count = matches ? matches.length : 0;

      // Retornar array com nomes de variáveis genéricos
      return Array.from({ length: count }, (_, i) => `var${i + 1}`);
    },
    chipStatusProtocolo(protocolo) {
      if (!protocolo) {
        return { text: "Aberto", color: "success" };
      }
      if (protocolo.status === "FECHADO") {
        return { text: "Fechado", color: "grey" };
      }
      if (!this.loggedIdUser) {
        return {
          text: protocolo.atendente ? "Em atendimento" : "Aberto",
          color: protocolo.atendente ? "grey" : "success",
        };
      }
      if (protocolo.participante === this.loggedIdUser) {
        return { text: "Participando", color: "#F2C94C" };
      }
      if (protocolo.atendente === this.loggedIdUser) {
        return { text: "Em atendimento", color: "info" };
      }
      if (protocolo.atendente) {
        return { text: "Em atendimento", color: "grey" };
      }
      return { text: "Aberto", color: "success" };
    },
    formatDateTimeBR(date) {
      if (!date) return "";
      return new Date(date).toLocaleString("pt-BR");
    },
    // Retorna a URL base (até antes de ?filename) para exibição de mídia
    getMediaUrl(contentUri) {
      if (!contentUri) return "";
      const idx = contentUri.indexOf("?filename");
      return idx > -1 ? contentUri.substring(0, idx) : contentUri;
    },
    // Verifica se o arquivo tem preview (imagem, vídeo, áudio ou PDF)
    hasMediaPreview(message) {
      if (!message?.contentUri) return false;
      const tipo = (message.tipo || "").toLowerCase();
      if (["image", "video", "audio"].includes(tipo)) return true;
      if (tipo === "document") return this.isPdfDocument(message.contentUri);
      return false;
    },
    isPdfDocument(contentUri) {
      if (!contentUri) return false;
      return /\.pdf(\?.*)?$/i.test(contentUri);
    },
    getFileName(contentUri) {
      if (!contentUri) return "arquivo";
      const match = contentUri.match(/\?filename=([^&]+)/i);
      return match ? decodeURIComponent(match[1]) : "arquivo";
    },
    abrirEmNovaAba(url) {
      if (url) window.open(url, "_blank");
    },
    getTipoLabel(tipo) {
      const map = {
        text: "Texto",
        image: "Imagem",
        audio: "Áudio",
        video: "Vídeo",
        document: "Documento",
        vcard: "Cartão de contato",
        geo: "Localização",
        wapi_template: "Template",
        BOT: "BOT",
        unsupported: "Não suportado",
        missing_call: "Chamada perdida",
        unknown: "Desconhecido",
      };
      return map[(tipo || "").toLowerCase()] || "Arquivo";
    },
    getTipoIcon(tipo) {
      const map = {
        image: "mdi-image",
        audio: "mdi-music-note",
        video: "mdi-video",
        document: "mdi-file-document-outline",
      };
      return map[(tipo || "").toLowerCase()] || "mdi-file-outline";
    },
    getTipoIconColor(tipo) {
      const map = {
        image: "primary",
        audio: "secondary",
        video: "purple",
        document: "teal",
      };
      return map[(tipo || "").toLowerCase()] || "grey";
    },
    getMapsUrl(conteudo) {
      if (!conteudo || typeof conteudo !== "string") return null;
      const coords = conteudo.match(/(-?\d+\.?\d*)\s*[,;]\s*(-?\d+\.?\d*)/);
      if (coords) {
        return `https://www.google.com/maps?q=${coords[1]},${coords[2]}`;
      }
      if (conteudo.startsWith("http")) return conteudo;
      return null;
    },
    formatarDataMensagem(dateStr) {
      if (!dateStr) return "";

      const data = new Date(dateStr);
      const agora = new Date();

      const mesmaData = data.toDateString() === agora.toDateString();

      const ontem = new Date();
      ontem.setDate(agora.getDate() - 1);

      const ehOntem = data.toDateString() === ontem.toDateString();

      const hora = data.toLocaleTimeString("pt-BR", {
        hour: "2-digit",
        minute: "2-digit",
      });

      if (mesmaData) {
        return hora;
      }

      if (ehOntem) {
        return `Ontem ${hora}`;
      }

      const dataFormatada = data.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year:
          data.getFullYear() !== agora.getFullYear() ? "numeric" : undefined,
      });

      return `${dataFormatada} ${hora}`;
    },

    // Obter referência do textarea
    getTextarea() {
      return document.querySelector(".message-input-area textarea");
    },

    // Formatar texto (negrito, itálico, sublinhado)
    formatar(tipo) {
      const textarea = this.getTextarea();
      if (!textarea) return;

      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      // Se não há texto selecionado, não faz nada
      if (start === end) return;

      const texto = this.freeTextMessage;
      const selecionado = texto.slice(start, end);

      // Define os marcadores por tipo
      const markers = {
        bold: "*",
        italic: "_",
        underline: "~",
      };

      const m = markers[tipo];

      let novo = selecionado;

      // Se já está formatado, remove a formatação
      if (selecionado.startsWith(m) && selecionado.endsWith(m)) {
        novo = selecionado.substring(1, selecionado.length - 1);
      } else {
        // Senão, adiciona a formatação
        novo = `${m}${selecionado}${m}`;
      }

      // Aplica a mudança no texto
      this.freeTextMessage = texto.slice(0, start) + novo + texto.slice(end);

      // Mantém a seleção após a formatação
      this.$nextTick(() => {
        textarea.focus();
        textarea.selectionStart = start;
        textarea.selectionEnd = start + novo.length;
      });
    },

    // Métodos para o emoji picker
    async toggleEmojiPicker() {
      // Carrega o emoji picker se ainda não foi carregado
      await loadEmojiPicker();
    },

    closeEmojiPicker() {
      this.showEmojiPicker = false;
    },

    onEmojiClick(event) {
      // Insere o emoji na posição atual do cursor ou no final do texto
      const emoji = event.detail.unicode;
      this.freeTextMessage += emoji;

      // Fecha o emoji picker após selecionar um emoji
      this.showEmojiPicker = false;
    },

    // Lidar com Enter no textarea (Shift+Enter para quebra de linha, Enter para enviar)
    handleEnter(event) {
      if (event.shiftKey) {
        // Shift+Enter: permite quebra de linha (comportamento padrão)
        return;
      }
      // Enter sem Shift: envia a mensagem
      event.preventDefault();
      this.enviarMensagem();
    },
  },
};
</script>
<style scoped>
.emoji-picker-container {
  max-height: 350px;
  overflow-y: auto;
  z-index: 9999;
}

.file-message {
  margin: 5px 0;
}

.file-message img {
  max-width: 100%;
  border-radius: 4px;
  transition: transform 0.2s;
}

.file-message img:hover {
  transform: scale(1.02);
}

/* Cards de mídia/arquivo */
.message-media-card {
  background: rgba(255, 255, 255, 0.6);
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
  max-width: 100%;
}

.message-media-card--subtle {
  background: rgba(0, 0, 0, 0.03);
}

.media-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: rgba(0, 0, 0, 0.02);
  flex-wrap: wrap;
}

.media-card-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #555;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.media-card-filename {
  font-size: 0.7rem;
  color: #888;
  margin-left: auto;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.media-card-body {
  padding: 12px 14px;
  font-size: 0.875rem;
  color: #333;
  line-height: 1.5;
}

.vcard-content {
  font-size: 0.75rem;
  white-space: pre-wrap;
  word-break: break-all;
  margin: 0;
  font-family: inherit;
}

.geo-content {
  margin-bottom: 8px;
}

.geo-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.8rem;
  color: #1976d2;
  text-decoration: none;
}

.geo-link:hover {
  text-decoration: underline;
}

.media-card-preview {
  padding: 10px 12px;
  background: rgba(0, 0, 0, 0.02);
}

.media-preview-img {
  max-width: 100%;
  max-height: 280px;
  border-radius: 8px;
  cursor: pointer;
  display: block;
  transition: transform 0.2s, box-shadow 0.2s;
}

.media-preview-img:hover {
  transform: scale(1.01);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.media-preview-video {
  max-width: 100%;
  max-height: 280px;
  border-radius: 8px;
  display: block;
}

.media-preview-audio {
  padding: 8px 0;
}

.media-preview-audio audio {
  width: 100%;
  max-width: 280px;
  height: 36px;
}

.media-preview-iframe {
  width: 100%;
  min-height: 360px;
  border: none;
  border-radius: 8px;
}

.media-card-actions {
  padding: 8px 12px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.media-card-actions--standalone {
  padding: 12px 14px;
}

.media-container {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.media-player-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.media-icon {
  font-size: 24px;
}

.audio-player {
  width: 250px;
  height: 40px;
  border-radius: 20px;
  outline: none;
}

.chat-container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.message-bubble {
  max-width: 70%;
  border-radius: 8px;
  word-break: break-word;
}

.outgoing-message {
  background-color: #cfe8ff;
  border-left: 3px solid #1565c0;
  margin-left: auto;
  border-top-right-radius: 0;
}

.incoming-message {
  background-color: #eceff1;
  border-right: 3px solid #90a4ae;
  margin-right: auto;
  border-top-left-radius: 0;
}

.outgoing-message-historico {
  background-color: #e6f3ff;
  border-left: 3px solid #90caf9;
  margin-left: auto;
  border-top-right-radius: 0;
}

.incoming-message-historico {
  background-color: #e8f5e9;
  align-self: flex-start;
  margin-right: auto;
  border-top-left-radius: 0;
}
.chat-card {
  min-height: 500px;
}

.protocols-card {
  min-height: 500px;
}

.protocols-list-container {
  max-height: 100%;
  overflow-y: auto;
}

.client-details-card {
  min-height: 500px;
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.expansion-panel {
  border-radius: 8px;
  border: 1px solid rgb(224 224 224);
}

.message-bubble.note-message {
  background-color: #f5f5f5;
  border-radius: 8px;
  color: #555;
  font-style: italic;
  max-width: 90%;
  margin: 0 auto;
  text-align: center;
}

.text-formatting-buttons {
  display: flex;
  gap: 4px;
  margin-left: 2px;
}

.note-message {
  background-color: #fff8e1;
  border-right: 3px solid #ffb300;
  align-self: flex-start;
  margin-right: auto;
  border-top-left-radius: 0;
}

.note-message-historico {
  background-color: #fff8e1;
  border-right: 3px solid #ffb300;
  align-self: flex-start;
  margin-right: auto;
  border-top-left-radius: 0;
}

.message-time {
  font-size: 0.7rem;
  color: #9e9e9e;
  margin-top: 2px;
  text-align: right;
  user-select: none;
}

/* Gravador de áudio */
.audio-recorder-container {
  padding: 10px;
}

.audio-visualizer {
  height: 80px;
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
}

.audio-visualizer.is-recording {
  background-color: rgba(244, 67, 54, 0.1);
}

.time-counter {
  font-size: 24px;
  font-weight: bold;
  color: #4caf50;
  margin-bottom: 10px;
}

.audio-visualizer.is-recording .time-counter {
  color: #f44336;
}

.wave-container {
  display: flex;
  align-items: center;
  height: 30px;
  gap: 4px;
}

.wave {
  width: 4px;
  height: 10px;
  background-color: #ccc;
  border-radius: 2px;
}

.audio-visualizer.is-recording .wave {
  background-color: #f44336;
  animation: wave 1s infinite ease-in-out;
}

.audio-visualizer.is-recording .wave:nth-child(1) {
  animation-delay: 0s;
}
.audio-visualizer.is-recording .wave:nth-child(2) {
  animation-delay: 0.2s;
}
.audio-visualizer.is-recording .wave:nth-child(3) {
  animation-delay: 0.4s;
}
.audio-visualizer.is-recording .wave:nth-child(4) {
  animation-delay: 0.6s;
}
.audio-visualizer.is-recording .wave:nth-child(5) {
  animation-delay: 0.8s;
}

@keyframes wave {
  0%,
  100% {
    height: 10px;
  }
  50% {
    height: 30px;
  }
}

.audio-controls {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.audio-preview-player {
  width: 100%;
  max-width: 300px;
}
</style>
